import { ref as w, defineComponent as se, inject as A, computed as z, withDirectives as Ve, openBlock as I, createElementBlock as D, normalizeClass as U, createBlock as te, resolveDynamicComponent as de, withCtx as re, createElementVNode as b, unref as T, createCommentVNode as Z, Fragment as we, renderList as ye, createVNode as W, createTextVNode as Pe, toDisplayString as Q, nextTick as Je, watch as K, onMounted as xe, onUnmounted as at, normalizeStyle as Cn, useCssVars as Pn, vModelText as On, normalizeProps as En, guardReactiveProps as Sn, vShow as nn, watchEffect as Dn, renderSlot as on, provide as ae, onBeforeUnmount as $n, createSlots as An } from "vue";
import { useDebounceFn as Bn, onClickOutside as Mn, useIntervalFn as Vn, useSwipe as sn } from "@vueuse/core";
import { $ as tt } from "./FrontiersClibConfigService.5b50b8d0.js";
import '../assets/Card.css';import '../assets/index20.css';/* empty css                                               */import { _ as Lt } from "./FrontiersImage.vue_vue_type_script_setup_true_lang.af02c3e5.js";
import { a as an, _ as Fn } from "./CardMetricList.vue_vue_type_script_setup_true_lang.7ac0d160.js";
import { Avatar as zn } from "../avatar.es.js";
import ft, { gsap as q } from "gsap";
import { _ as Rn } from "./Card.vue_vue_type_script_setup_true_lang.c8cda490.js";
import { FullScreenIcon as jt, ArrowRightIcon as Nn, ImageIcon as Wn, LessIcon as jn, MoreCircledIcon as Hn, DownloadIcon as ln, CloseIcon as Yn, ChevronDownIcon as Un } from "@frontiers/brink-icons";
import { ButtonIcon as De } from "../buttonIcon.es.js";
import Xn from "@panzoom/panzoom";
import { B as rn, g as Ct, a as un, b as Fe, c as Jn, d as Ht, v as qn } from "./BodyScrollLock.945be9eb.js";
import { OnClickOutside as cn } from "@vueuse/components";
import { ScrollTrigger as Yt } from "gsap/ScrollTrigger";
function Gn(l) {
  const e = [], n = /* @__PURE__ */ new Map();
  return l.forEach((o) => {
    o.affiliations.forEach((i) => {
      const s = JSON.stringify(i);
      if (!n.has(s)) {
        const u = e.length + 1, a = Object.values(i).filter((r) => r).join(", ");
        e.push({
          ...i,
          affiliations: a,
          index: u
        }), n.set(s, u);
      }
    });
  }), {
    people: l.map((o) => {
      const i = o.affiliations.map(
        (s) => {
          const u = JSON.stringify(s);
          return n.get(u);
        }
      );
      return { ...o, affiliationIndexes: i };
    }),
    organizations: e
  };
}
const Qe = [
  "bottomcenter",
  "bottomleft",
  "leftbottom",
  "leftcenter",
  "lefttop",
  "topleft",
  "topcenter",
  "topright",
  "righttop",
  "rightcenter",
  "rightbottom",
  "bottomright"
], Zn = ["top", "right", "left", "bottom"], Kn = [
  "center",
  "top",
  "right",
  "left",
  "bottom"
], Qn = (l) => {
  const e = Qe.indexOf(l);
  return Qe[e + 1] || Qe[0];
}, ei = (l) => Qe.includes(l), ti = (l, e) => {
  const n = window.innerWidth;
  let t = e;
  const o = [
    { max: 563, attribute: "po:mobile" },
    { min: 564, max: 768, attribute: "po:tablet-portrait" },
    { min: 769, max: 1024, attribute: "po:tablet-landscape" },
    { min: 1025, max: 1280, attribute: "po:laptop-small" },
    { min: 1281, max: 1440, attribute: "po:laptop" },
    { min: 1441, attribute: "po:desktop" }
  ];
  for (const { min: i = -1 / 0, max: s = 1 / 0, attribute: u } of o)
    if (n >= i && n < s) {
      const a = l.getAttribute(u);
      a && (ei(a || "") ? t = a : console.warn(
        `[directive:popover] the position "${a}" defined for the breakpoint ${u}, is not valid, modifier position or default position will be used.)`
      ));
    }
  return t;
}, nt = (l, e) => {
  var u;
  const n = l.modifiers;
  let t = ((u = l.value) == null ? void 0 : u.position) || "bottomcenter", o = "click";
  const i = Object.keys(n).filter((a) => {
    if (a !== "click" && a !== "hover")
      return a;
  }), s = Object.keys(n).filter((a) => {
    if (a === "click" || a === "hover")
      return a;
  });
  return i.length >= 1 && (t = i[0]), s.length >= 1 && (o = s[0]), {
    modifiersPosition: i,
    modifiersAction: s,
    modifierPosition: ti(e, t),
    modifierAction: o
  };
}, Pt = (l) => {
  let e = "bottom", n = "center";
  for (const t of Zn)
    l.startsWith(t) && (e = t);
  for (const t of Kn)
    l.endsWith(t) && (n = t);
  return {
    placement: e,
    alignment: n
  };
}, ni = (l, e) => {
  const { modifiersPosition: n, modifiersAction: t } = nt(l, e);
  n.length > 1 && console.warn(
    `[directive:popover] there are more than one modifiers for position, only the first one will be used (${n})`
  ), t.length > 1 && console.warn(
    `[directive:popover] there are more than one modifiers for action, only the first one will be used (${n})`
  );
}, dn = (l, e, n) => {
  if (!n)
    return;
  const { placement: t, alignment: o } = Pt(e), i = l.getBoundingClientRect(), s = window.scrollY;
  if (t === "top" && (n.style.top = `${i.top + s}px`), t === "bottom" && (n.style.top = `${i.top + s + i.height}px`), t === "top" || t === "bottom")
    if (Math.min(window.innerWidth, screen.width) < 400) {
      const a = n.querySelector(".Popover__arrow"), r = Math.min(window.innerWidth, screen.width) / 2 - n.offsetWidth / 2, c = i.left + i.width / 2 - r;
      n.style.left = `${r}px`, a.style.left = `${c}px`, a.style.right = "auto";
    } else
      o === "center" && (n.style.left = `${i.left + i.width / 2}px`), o === "left" && (n.style.left = `${i.left}px`), o === "right" && (n.style.left = `${i.right}px`);
  t === "left" && (n.style.left = `${i.left}px`), t === "right" && (n.style.left = `${i.left + i.width}px`), (t === "left" || t === "right") && (o === "center" && (n.style.top = `${i.top + s + i.height / 2}px`), o === "top" && (n.style.top = `${i.top + s}px`), o === "bottom" && (n.style.top = `${i.bottom + s}px`));
}, Ot = Bn((l) => {
  Le(l);
}, 150), ii = (l) => {
  l.classList.value = "Popover";
  const e = l.querySelector(".Popover__arrow");
  e.classList.value = "Popover__arrow", l.style.cssText = "", e.style.cssText = "";
}, fn = (l, e, n, t) => {
  const o = e.getBoundingClientRect();
  if (!(o.top >= 56 && o.left >= 2 && o.bottom <= Math.min(window.innerHeight, screen.height) - 2 && o.right <= Math.min(window.innerWidth, screen.width) - 17)) {
    ii(e);
    const s = Qn(n), { placement: u, alignment: a } = Pt(s);
    e.classList.add(
      "Popover",
      `Popover--${u}`,
      `Popover--a${a}`
    ), e.querySelector(".Popover__arrow").classList.add(`Popover__arrow--${s}`), dn(l, s, e), fn(l, e, s);
  }
}, yt = (l, e) => {
  const n = l;
  if (n.isVisible = !0, !e.value || e.value.message.length === 0)
    return;
  const t = document.createElement("div"), o = document.querySelector("body"), { modifierPosition: i } = nt(e, l), { placement: s, alignment: u } = Pt(i);
  t.classList.add(
    "Popover",
    `Popover--${s}`,
    `Popover--a${u}`
  );
  const a = `
    <div class="Popover__arrow Popover__arrow--${i}"></div>
    <button class="Popover__close" aria-label="Close the popover"></button>
    <div class="Popover__content">
      ${e.value.message}
    </div>
  `;
  t.innerHTML = a, o.appendChild(t), n.popoverEl = t, dn(l, i, t), fn(l, t, i);
  const r = w(t);
  Mn(r, (d) => {
    const p = d.target;
    p === l || l.contains(p) || Le(l);
  }), t.querySelector(".Popover__close").addEventListener("click", () => {
    Le(l);
  }), window.addEventListener("resize", () => {
    Ot(l);
  });
}, Le = (l) => {
  const e = l;
  e.isVisible = !1, e.popoverEl && (window.removeEventListener("resize", () => {
    Ot(l);
  }), e.popoverEl.remove(), e.popoverEl = null);
}, Ut = (l, e) => {
  l.isVisible ? Le(l) : yt(l, e);
}, oi = {
  mounted(l, e) {
    const n = l;
    n.isVisible = !1, typeof e.value == "string" && (e.value = { message: e.value }), ni(e, l);
    const { modifierAction: t } = nt(e, l);
    t === "click" && l.addEventListener("click", () => {
      Ut(l, e);
    }), t === "hover" && (l.addEventListener("mouseover", () => {
      yt(l, e);
    }), l.addEventListener("mouseleave", () => {
      Le(l);
    }));
  },
  unmounted(l, e) {
    const { modifierAction: n } = nt(e, l);
    n === "click" && l.removeEventListener("click", () => {
      Ut(l, e);
    }), n === "hover" && (l.removeEventListener("mouseover", () => {
      yt(l, e.value);
    }), l.removeEventListener("mouseleave", () => {
      Le(l);
    })), Le(l), window.removeEventListener("resize", () => {
      Ot(l);
    });
  }
}, si = /* @__PURE__ */ b("div", { class: "CardJournal__Header" }, "Published in", -1), ai = { class: "CardJournal__ImgWrapper" }, li = /* @__PURE__ */ b("div", { class: "CardJournal__ImgBorder" }, null, -1), ri = { class: "CardJournal__Body" }, ui = ["innerHTML"], ci = {
  key: 0,
  class: "CardJournal__offlineTag"
}, di = { class: "CardJournal__sections" }, fi = {
  key: 0,
  class: "CardJournal__offlineTag"
}, pi = {
  key: 0,
  class: "CardJournal__Footer"
}, os = /* @__PURE__ */ se({
  __name: "CardJournal",
  props: {
    journal: {},
    sections: { default: () => [] },
    heading: { default: "h3" },
    sectionHeading: { default: "h4" },
    popover: {}
  },
  setup(l) {
    const e = l, n = A("sanitize"), t = z(() => {
      const a = [];
      return e.journal.impactFactor && a.push({ value: e.journal.impactFactor, text: "impact factor" }), e.journal.citeScore && a.push({ value: e.journal.citeScore, text: "citescore" }), a;
    }), o = z(() => t.value.length > 0), i = z(() => e.sections.find((a) => a.isOnline)), s = z(() => {
      let a = `https://www.${tt.getMainDomain}/journals/${e.journal.slug}`;
      return !e.journal.isOnline && i.value && (a = `https://www.${tt.getMainDomain}/journals/${e.journal.slug}/sections/${i.value.slug}`), { text: "Image text", url: a, ariaLabel: "Go to section page" };
    }), u = z(() => !e.journal.isOnline && !i.value);
    return (a, r) => Ve((I(), D("article", {
      class: U(["CardJournal", {
        "CardJournal--disabled": u.value
      }])
    }, [
      (I(), te(de(u.value ? "div" : "a"), {
        class: "CardJournal__Link",
        href: u.value ? "" : s.value.url,
        "aria-label": s.value.ariaLabel,
        "data-event": a.$ga.getDataEventValue("CardJournal", "a"),
        target: "_blank"
      }, {
        default: re(() => [
          si,
          b("div", ai, [
            a.journal.image ? (I(), te(T(Lt), {
              key: 0,
              class: "CardJournal__Img",
              sources: a.journal.image.sources,
              imageAlt: a.journal.image.imageAlt
            }, null, 8, ["sources", "imageAlt"])) : Z("", !0),
            li
          ]),
          b("div", ri, [
            (I(), te(de(a.heading), { class: "CardJournal__Title CardJournal__Title--journal" }, {
              default: re(() => [
                b("span", {
                  innerHTML: T(n)(a.journal.name) + " "
                }, null, 8, ui),
                a.journal.isOnline ? Z("", !0) : (I(), D("span", ci, " Offline "))
              ]),
              _: 1
            })),
            b("ul", di, [
              (I(!0), D(we, null, ye(a.sections, (c) => (I(), D("li", {
                class: "CardJournal__Title CardJournal__Title--section",
                key: c.id
              }, [
                (I(), te(de(a.sectionHeading), {
                  class: "sectionTitle",
                  innerHTML: T(n)(c.name)
                }, null, 8, ["innerHTML"])),
                c.isOnline ? Z("", !0) : (I(), D("span", fi, "Offline"))
              ]))), 128))
            ])
          ]),
          o.value ? (I(), D("div", pi, [
            W(T(an), { metrics: t.value }, null, 8, ["metrics"])
          ])) : Z("", !0)
        ]),
        _: 1
      }, 8, ["href", "aria-label", "data-event"]))
    ], 2)), [
      [
        T(oi),
        e.popover,
        void 0,
        { click: !0 }
      ]
    ]);
  }
}), hi = { class: "PeopleListItem__name notranslate" }, vi = { key: 0 }, Xt = /* @__PURE__ */ se({
  __name: "PeopleListItem",
  props: {
    fullName: {},
    affiliationIndexes: {},
    userId: {},
    symbols: {}
  },
  setup(l) {
    const e = l, n = z(() => e.affiliationIndexes.join(",")), t = z(() => e.userId && e.userId > 0 ? `${tt.getLoopUrl}/images/profile/${e.userId}/74` : ""), o = z(() => e.userId && e.userId > 0 ? `${tt.getLoopUrl}/people/${e.userId}` : ""), i = z(() => e.userId && e.userId > 0 ? "a" : "div");
    return (s, u) => (I(), te(de(i.value), {
      class: "PeopleListItem",
      href: o.value,
      "data-event": i.value === "a" ? s.$ga.getDataEventValue("PeopleListItem", "a") : null
    }, {
      default: re(() => [
        W(T(zn), {
          class: "PeopleListItem__Avatar",
          "full-name": s.fullName,
          src: t.value,
          color: "Grey",
          size: "Size40"
        }, null, 8, ["full-name", "src"]),
        b("p", hi, [
          Pe(Q(s.fullName) + " ", 1),
          b("sup", null, Q(n.value), 1),
          s.symbols ? (I(), D("sup", vi, Q(s.symbols), 1)) : Z("", !0)
        ])
      ]),
      _: 1
    }, 8, ["href", "data-event"]));
  }
});
/*!
 * matrix 3.12.0
 * https://greensock.com
 *
 * Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var _e, Ce, Et, Be, je, et, it, He, ue = "transform", It = ue + "Origin", pn, St = function(e) {
  var n = e.ownerDocument || e;
  for (!(ue in e.style) && ("msTransform" in e.style) && (ue = "msTransform", It = ue + "Origin"); n.parentNode && (n = n.parentNode); )
    ;
  if (Ce = window, it = new Oe(), n) {
    _e = n, Et = n.documentElement, Be = n.body, He = _e.createElementNS("http://www.w3.org/2000/svg", "g"), He.style.transform = "none";
    var t = n.createElement("div"), o = n.createElement("div");
    Be.appendChild(t), t.appendChild(o), t.style.position = "static", t.style[ue] = "translate3d(0,0,1px)", pn = o.offsetParent !== t, Be.removeChild(t);
  }
  return n;
}, gi = function(e) {
  for (var n, t; e && e !== Be; )
    t = e._gsap, t && t.uncache && t.get(e, "x"), t && !t.scaleX && !t.scaleY && t.renderTransform && (t.scaleX = t.scaleY = 1e-4, t.renderTransform(1, t), n ? n.push(t) : n = [t]), e = e.parentNode;
  return n;
}, hn = [], vn = [], Dt = function() {
  return Ce.pageYOffset || _e.scrollTop || Et.scrollTop || Be.scrollTop || 0;
}, $t = function() {
  return Ce.pageXOffset || _e.scrollLeft || Et.scrollLeft || Be.scrollLeft || 0;
}, At = function(e) {
  return e.ownerSVGElement || ((e.tagName + "").toLowerCase() === "svg" ? e : null);
}, mi = function l(e) {
  if (Ce.getComputedStyle(e).position === "fixed")
    return !0;
  if (e = e.parentNode, e && e.nodeType === 1)
    return l(e);
}, pt = function l(e, n) {
  if (e.parentNode && (_e || St(e))) {
    var t = At(e), o = t ? t.getAttribute("xmlns") || "http://www.w3.org/2000/svg" : "http://www.w3.org/1999/xhtml", i = t ? n ? "rect" : "g" : "div", s = n !== 2 ? 0 : 100, u = n === 3 ? 100 : 0, a = "position:absolute;display:block;pointer-events:none;margin:0;padding:0;", r = _e.createElementNS ? _e.createElementNS(o.replace(/^https/, "http"), i) : _e.createElement(i);
    return n && (t ? (et || (et = l(e)), r.setAttribute("width", 0.01), r.setAttribute("height", 0.01), r.setAttribute("transform", "translate(" + s + "," + u + ")"), et.appendChild(r)) : (je || (je = l(e), je.style.cssText = a), r.style.cssText = a + "width:0.1px;height:0.1px;top:" + u + "px;left:" + s + "px", je.appendChild(r))), r;
  }
  throw "Need document and parent.";
}, _i = function(e) {
  for (var n = new Oe(), t = 0; t < e.numberOfItems; t++)
    n.multiply(e.getItem(t).matrix);
  return n;
}, gn = function(e) {
  var n = e.getCTM(), t;
  return n || (t = e.style[ue], e.style[ue] = "none", e.appendChild(He), n = He.getCTM(), e.removeChild(He), t ? e.style[ue] = t : e.style.removeProperty(ue.replace(/([A-Z])/g, "-$1").toLowerCase())), n || it.clone();
}, bi = function(e, n) {
  var t = At(e), o = e === t, i = t ? hn : vn, s = e.parentNode, u, a, r, c, d, p;
  if (e === Ce)
    return e;
  if (i.length || i.push(pt(e, 1), pt(e, 2), pt(e, 3)), u = t ? et : je, t)
    o ? (r = gn(e), c = -r.e / r.a, d = -r.f / r.d, a = it) : e.getBBox ? (r = e.getBBox(), a = e.transform ? e.transform.baseVal : {}, a = a.numberOfItems ? a.numberOfItems > 1 ? _i(a) : a.getItem(0).matrix : it, c = a.a * r.x + a.c * r.y, d = a.b * r.x + a.d * r.y) : (a = new Oe(), c = d = 0), n && e.tagName.toLowerCase() === "g" && (c = d = 0), (o ? t : s).appendChild(u), u.setAttribute("transform", "matrix(" + a.a + "," + a.b + "," + a.c + "," + a.d + "," + (a.e + c) + "," + (a.f + d) + ")");
  else {
    if (c = d = 0, pn)
      for (a = e.offsetParent, r = e; r && (r = r.parentNode) && r !== a && r.parentNode; )
        (Ce.getComputedStyle(r)[ue] + "").length > 4 && (c = r.offsetLeft, d = r.offsetTop, r = 0);
    if (p = Ce.getComputedStyle(e), p.position !== "absolute" && p.position !== "fixed")
      for (a = e.offsetParent; s && s !== a; )
        c += s.scrollLeft || 0, d += s.scrollTop || 0, s = s.parentNode;
    r = u.style, r.top = e.offsetTop - d + "px", r.left = e.offsetLeft - c + "px", r[ue] = p[ue], r[It] = p[It], r.position = p.position === "fixed" ? "fixed" : "absolute", e.parentNode.appendChild(u);
  }
  return u;
}, ht = function(e, n, t, o, i, s, u) {
  return e.a = n, e.b = t, e.c = o, e.d = i, e.e = s, e.f = u, e;
}, Oe = /* @__PURE__ */ function() {
  function l(n, t, o, i, s, u) {
    n === void 0 && (n = 1), t === void 0 && (t = 0), o === void 0 && (o = 0), i === void 0 && (i = 1), s === void 0 && (s = 0), u === void 0 && (u = 0), ht(this, n, t, o, i, s, u);
  }
  var e = l.prototype;
  return e.inverse = function() {
    var t = this.a, o = this.b, i = this.c, s = this.d, u = this.e, a = this.f, r = t * s - o * i || 1e-10;
    return ht(this, s / r, -o / r, -i / r, t / r, (i * a - s * u) / r, -(t * a - o * u) / r);
  }, e.multiply = function(t) {
    var o = this.a, i = this.b, s = this.c, u = this.d, a = this.e, r = this.f, c = t.a, d = t.c, p = t.b, f = t.d, g = t.e, C = t.f;
    return ht(this, c * o + p * s, c * i + p * u, d * o + f * s, d * i + f * u, a + g * o + C * s, r + g * i + C * u);
  }, e.clone = function() {
    return new l(this.a, this.b, this.c, this.d, this.e, this.f);
  }, e.equals = function(t) {
    var o = this.a, i = this.b, s = this.c, u = this.d, a = this.e, r = this.f;
    return o === t.a && i === t.b && s === t.c && u === t.d && a === t.e && r === t.f;
  }, e.apply = function(t, o) {
    o === void 0 && (o = {});
    var i = t.x, s = t.y, u = this.a, a = this.b, r = this.c, c = this.d, d = this.e, p = this.f;
    return o.x = i * u + s * r + d || 0, o.y = i * a + s * c + p || 0, o;
  }, l;
}();
function he(l, e, n, t) {
  if (!l || !l.parentNode || (_e || St(l)).documentElement === l)
    return new Oe();
  var o = gi(l), i = At(l), s = i ? hn : vn, u = bi(l, n), a = s[0].getBoundingClientRect(), r = s[1].getBoundingClientRect(), c = s[2].getBoundingClientRect(), d = u.parentNode, p = !t && mi(l), f = new Oe((r.left - a.left) / 100, (r.top - a.top) / 100, (c.left - a.left) / 100, (c.top - a.top) / 100, a.left + (p ? 0 : $t()), a.top + (p ? 0 : Dt()));
  if (d.removeChild(u), o)
    for (a = o.length; a--; )
      r = o[a], r.scaleX = r.scaleY = 0, r.renderTransform(1, r);
  return e ? f.inverse() : f;
}
/*!
 * Flip 3.12.0
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var wi = 1, ze, oe, Y, Ye, ke, be, kt, Jt = function(e, n) {
  return e.actions.forEach(function(t) {
    return t.vars[n] && t.vars[n](t);
  });
}, xt = {}, qt = 180 / Math.PI, yi = Math.PI / 180, ot = {}, Gt = {}, lt = {}, Bt = function(e) {
  return typeof e == "string" ? e.split(" ").join("").split(",") : e;
}, Ii = Bt("onStart,onUpdate,onComplete,onReverseComplete,onInterrupt"), rt = Bt("transform,transformOrigin,width,height,position,top,left,opacity,zIndex,maxWidth,maxHeight,minWidth,minHeight"), Ue = function(e) {
  return ze(e)[0] || console.warn("Element not found:", e);
}, $e = function(e) {
  return Math.round(e * 1e4) / 1e4 || 0;
}, vt = function(e, n, t) {
  return e.forEach(function(o) {
    return o.classList[t](n);
  });
}, Zt = {
  zIndex: 1,
  kill: 1,
  simple: 1,
  spin: 1,
  clearProps: 1,
  targets: 1,
  toggleClass: 1,
  onComplete: 1,
  onUpdate: 1,
  onInterrupt: 1,
  onStart: 1,
  delay: 1,
  repeat: 1,
  repeatDelay: 1,
  yoyo: 1,
  scale: 1,
  fade: 1,
  absolute: 1,
  props: 1,
  onEnter: 1,
  onLeave: 1,
  custom: 1,
  paused: 1,
  nested: 1,
  prune: 1,
  absoluteOnLeave: 1
}, mn = {
  zIndex: 1,
  simple: 1,
  clearProps: 1,
  scale: 1,
  absolute: 1,
  fitChild: 1,
  getVars: 1,
  props: 1
}, _n = function(e) {
  return e.replace(/([A-Z])/g, "-$1").toLowerCase();
}, Ae = function(e, n) {
  var t = {}, o;
  for (o in e)
    n[o] || (t[o] = e[o]);
  return t;
}, Mt = {}, bn = function(e) {
  var n = Mt[e] = Bt(e);
  return lt[e] = n.concat(rt), n;
}, ki = function(e) {
  var n = e._gsap || oe.core.getCache(e);
  return n.gmCache === oe.ticker.frame ? n.gMatrix : (n.gmCache = oe.ticker.frame, n.gMatrix = he(e, !0, !1, !0));
}, xi = function l(e, n, t) {
  t === void 0 && (t = 0);
  for (var o = e.parentNode, i = 1e3 * Math.pow(10, t) * (n ? -1 : 1), s = n ? -i * 900 : 0; e; )
    s += i, e = e.previousSibling;
  return o ? s + l(o, n, t + 1) : s;
}, st = function(e, n, t) {
  return e.forEach(function(o) {
    return o.d = xi(t ? o.element : o.t, n);
  }), e.sort(function(o, i) {
    return o.d - i.d;
  }), e;
}, Xe = function(e, n) {
  for (var t = e.element.style, o = e.css = e.css || [], i = n.length, s, u; i--; )
    s = n[i], u = t[s] || t.getPropertyValue(s), o.push(u ? s : Gt[s] || (Gt[s] = _n(s)), u);
  return t;
}, Vt = function(e) {
  var n = e.css, t = e.element.style, o = 0;
  for (e.cache.uncache = 1; o < n.length; o += 2)
    n[o + 1] ? t[n[o]] = n[o + 1] : t.removeProperty(n[o]);
  !n[n.indexOf("transform") + 1] && t.translate && (t.removeProperty("translate"), t.removeProperty("scale"), t.removeProperty("rotate"));
}, Kt = function(e, n) {
  e.forEach(function(t) {
    return t.a.cache.uncache = 1;
  }), n || e.finalStates.forEach(Vt);
}, gt = "paddingTop,paddingRight,paddingBottom,paddingLeft,gridArea,transition".split(","), Ft = function(e, n, t) {
  var o = e.element, i = e.width, s = e.height, u = e.uncache, a = e.getProp, r = o.style, c = 4, d, p, f;
  if (typeof n != "object" && (n = e), Y && t !== 1)
    return Y._abs.push({
      t: o,
      b: e,
      a: e,
      sd: 0
    }), Y._final.push(function() {
      return (e.cache.uncache = 1) && Vt(e);
    }), o;
  for (p = a("display") === "none", (!e.isVisible || p) && (p && (Xe(e, ["display"]).display = n.display), e.matrix = n.matrix, e.width = i = e.width || n.width, e.height = s = e.height || n.height), Xe(e, gt), f = window.getComputedStyle(o); c--; )
    r[gt[c]] = f[gt[c]];
  if (r.gridArea = "1 / 1 / 1 / 1", r.transition = "none", r.position = "absolute", r.width = i + "px", r.height = s + "px", r.top || (r.top = "0px"), r.left || (r.left = "0px"), u)
    d = new Ee(o);
  else if (d = Ae(e, ot), d.position = "absolute", e.simple) {
    var g = o.getBoundingClientRect();
    d.matrix = new Oe(1, 0, 0, 1, g.left + $t(), g.top + Dt());
  } else
    d.matrix = he(o, !1, !1, !0);
  return d = Me(d, e, !0), e.x = be(d.x, 0.01), e.y = be(d.y, 0.01), o;
}, Qt = function(e, n) {
  return n !== !0 && (n = ze(n), e = e.filter(function(t) {
    if (n.indexOf((t.sd < 0 ? t.b : t.a).element) !== -1)
      return !0;
    t.t._gsap.renderTransform(1), t.b.isVisible && (t.t.style.width = t.b.width + "px", t.t.style.height = t.b.height + "px");
  })), e;
}, wn = function(e) {
  return st(e, !0).forEach(function(n) {
    return (n.a.isVisible || n.b.isVisible) && Ft(n.sd < 0 ? n.b : n.a, n.b, 1);
  });
}, Ti = function(e, n) {
  return n && e.idLookup[Tt(n).id] || e.elementStates[0];
}, Tt = function(e, n, t, o) {
  return e instanceof Ee ? e : e instanceof fe ? Ti(e, o) : new Ee(typeof e == "string" ? Ue(e) || console.warn(e + " not found") : e, n, t);
}, Li = function(e, n) {
  for (var t = oe.getProperty(e.element, null, "native"), o = e.props = {}, i = n.length; i--; )
    o[n[i]] = (t(n[i]) + "").trim();
  return o.zIndex && (o.zIndex = parseFloat(o.zIndex) || 0), e;
}, yn = function(e, n) {
  var t = e.style || e, o;
  for (o in n)
    t[o] = n[o];
}, Ci = function(e) {
  var n = e.getAttribute("data-flip-id");
  return n || e.setAttribute("data-flip-id", n = "auto-" + wi++), n;
}, In = function(e) {
  return e.map(function(n) {
    return n.element;
  });
}, en = function(e, n, t) {
  return e && n.length && t.add(e(In(n), t, new fe(n, 0, !0)), 0);
}, Me = function(e, n, t, o, i, s) {
  var u = e.element, a = e.cache, r = e.parent, c = e.x, d = e.y, p = n.width, f = n.height, g = n.scaleX, C = n.scaleY, k = n.rotation, h = n.bounds, E = s && kt && kt(u, "transform"), v = e, F = n.matrix, P = F.e, L = F.f, M = e.bounds.width !== h.width || e.bounds.height !== h.height || e.scaleX !== g || e.scaleY !== C || e.rotation !== k, S = !M && e.simple && n.simple && !i, _, m, x, y, B, $, O;
  return S || !r ? (g = C = 1, k = _ = 0) : (B = ki(r), $ = B.clone().multiply(n.ctm ? n.matrix.clone().multiply(n.ctm) : n.matrix), k = $e(Math.atan2($.b, $.a) * qt), _ = $e(Math.atan2($.c, $.d) * qt + k) % 360, g = Math.sqrt(Math.pow($.a, 2) + Math.pow($.b, 2)), C = Math.sqrt(Math.pow($.c, 2) + Math.pow($.d, 2)) * Math.cos(_ * yi), i && (i = ze(i)[0], y = oe.getProperty(i), O = i.getBBox && typeof i.getBBox == "function" && i.getBBox(), v = {
    scaleX: y("scaleX"),
    scaleY: y("scaleY"),
    width: O ? O.width : Math.ceil(parseFloat(y("width", "px"))),
    height: O ? O.height : parseFloat(y("height", "px"))
  }), a.rotation = k + "deg", a.skewX = _ + "deg"), t ? (g *= p === v.width || !v.width ? 1 : p / v.width, C *= f === v.height || !v.height ? 1 : f / v.height, a.scaleX = g, a.scaleY = C) : (p = be(p * g / v.scaleX, 0), f = be(f * C / v.scaleY, 0), u.style.width = p + "px", u.style.height = f + "px"), o && yn(u, n.props), S || !r ? (c += P - e.matrix.e, d += L - e.matrix.f) : M || r !== n.parent ? (a.renderTransform(1, a), $ = he(i || u, !1, !1, !0), m = B.apply({
    x: $.e,
    y: $.f
  }), x = B.apply({
    x: P,
    y: L
  }), c += x.x - m.x, d += x.y - m.y) : (B.e = B.f = 0, x = B.apply({
    x: P - e.matrix.e,
    y: L - e.matrix.f
  }), c += x.x, d += x.y), c = be(c, 0.02), d = be(d, 0.02), s && !(s instanceof Ee) ? E && E.revert() : (a.x = c + "px", a.y = d + "px", a.renderTransform(1, a)), s && (s.x = c, s.y = d, s.rotation = k, s.skewX = _, t ? (s.scaleX = g, s.scaleY = C) : (s.width = p, s.height = f)), s || a;
}, mt = function(e, n) {
  return e instanceof fe ? e : new fe(e, n);
}, kn = function(e, n, t) {
  var o = e.idLookup[t], i = e.alt[t];
  return i.isVisible && (!(n.getElementState(i.element) || i).isVisible || !o.isVisible) ? i : o;
}, _t = [], bt = "width,height,overflowX,overflowY".split(","), Ge, tn = function(e) {
  if (e !== Ge) {
    var n = ke.style, t = ke.clientWidth === window.outerWidth, o = ke.clientHeight === window.outerHeight, i = 4;
    if (e && (t || o)) {
      for (; i--; )
        _t[i] = n[bt[i]];
      t && (n.width = ke.clientWidth + "px", n.overflowY = "hidden"), o && (n.height = ke.clientHeight + "px", n.overflowX = "hidden"), Ge = e;
    } else if (Ge) {
      for (; i--; )
        _t[i] ? n[bt[i]] = _t[i] : n.removeProperty(_n(bt[i]));
      Ge = e;
    }
  }
}, wt = function(e, n, t, o) {
  e instanceof fe && n instanceof fe || console.warn("Not a valid state object."), t = t || {};
  var i = t, s = i.clearProps, u = i.onEnter, a = i.onLeave, r = i.absolute, c = i.absoluteOnLeave, d = i.custom, p = i.delay, f = i.paused, g = i.repeat, C = i.repeatDelay, k = i.yoyo, h = i.toggleClass, E = i.nested, v = i.zIndex, F = i.scale, P = i.fade, L = i.stagger, M = i.spin, S = i.prune, _ = ("props" in t ? t : e).props, m = Ae(t, Zt), x = oe.timeline({
    delay: p,
    paused: f,
    repeat: g,
    repeatDelay: C,
    yoyo: k,
    data: "isFlip"
  }), y = m, B = [], $ = [], O = [], ne = [], pe = M === !0 ? 1 : M || 0, Re = typeof M == "function" ? M : function() {
    return pe;
  }, Ne = e.interrupted || n.interrupted, qe = x[o !== 1 ? "to" : "from"], Ie, ee, R, j, H, N, ce, le, Se, ve, ge, ut, J, ie;
  for (ee in n.idLookup)
    ge = n.alt[ee] ? kn(n, e, ee) : n.idLookup[ee], H = ge.element, ve = e.idLookup[ee], e.alt[ee] && H === ve.element && (e.alt[ee].isVisible || !ge.isVisible) && (ve = e.alt[ee]), ve ? (N = {
      t: H,
      b: ve,
      a: ge,
      sd: ve.element === H ? 0 : ge.isVisible ? 1 : -1
    }, O.push(N), N.sd && (N.sd < 0 && (N.b = ge, N.a = ve), Ne && Xe(N.b, _ ? lt[_] : rt), P && O.push(N.swap = {
      t: ve.element,
      b: N.b,
      a: N.a,
      sd: -N.sd,
      swap: N
    })), H._flip = ve.element._flip = Y ? Y.timeline : x) : ge.isVisible && (O.push({
      t: H,
      b: Ae(ge, {
        isVisible: 1
      }),
      a: ge,
      sd: 0,
      entering: 1
    }), H._flip = Y ? Y.timeline : x);
  if (_ && (Mt[_] || bn(_)).forEach(function(me) {
    return m[me] = function(Te) {
      return O[Te].a.props[me];
    };
  }), O.finalStates = Se = [], ut = function() {
    for (st(O), tn(!0), j = 0; j < O.length; j++)
      N = O[j], J = N.a, ie = N.b, S && !J.isDifferent(ie) && !N.entering ? O.splice(j--, 1) : (H = N.t, E && !(N.sd < 0) && j && (J.matrix = he(H, !1, !1, !0)), ie.isVisible && J.isVisible ? (N.sd < 0 ? (ce = new Ee(H, _, e.simple), Me(ce, J, F, 0, 0, ce), ce.matrix = he(H, !1, !1, !0), ce.css = N.b.css, N.a = J = ce, P && (H.style.opacity = Ne ? ie.opacity : J.opacity), L && ne.push(H)) : N.sd > 0 && P && (H.style.opacity = Ne ? J.opacity - ie.opacity : "0"), Me(J, ie, F, _)) : ie.isVisible !== J.isVisible && (ie.isVisible ? J.isVisible || (ie.css = J.css, $.push(ie), O.splice(j--, 1), r && E && Me(J, ie, F, _)) : (J.isVisible && B.push(J), O.splice(j--, 1))), F || (H.style.maxWidth = Math.max(J.width, ie.width) + "px", H.style.maxHeight = Math.max(J.height, ie.height) + "px", H.style.minWidth = Math.min(J.width, ie.width) + "px", H.style.minHeight = Math.min(J.height, ie.height) + "px"), E && h && H.classList.add(h)), Se.push(J);
    var Te;
    if (h && (Te = Se.map(function(V) {
      return V.element;
    }), E && Te.forEach(function(V) {
      return V.classList.remove(h);
    })), tn(!1), F ? (m.scaleX = function(V) {
      return O[V].a.scaleX;
    }, m.scaleY = function(V) {
      return O[V].a.scaleY;
    }) : (m.width = function(V) {
      return O[V].a.width + "px";
    }, m.height = function(V) {
      return O[V].a.height + "px";
    }, m.autoRound = t.autoRound || !1), m.x = function(V) {
      return O[V].a.x + "px";
    }, m.y = function(V) {
      return O[V].a.y + "px";
    }, m.rotation = function(V) {
      return O[V].a.rotation + (M ? Re(V, le[V], le) * 360 : 0);
    }, m.skewX = function(V) {
      return O[V].a.skewX;
    }, le = O.map(function(V) {
      return V.t;
    }), (v || v === 0) && (m.modifiers = {
      zIndex: function() {
        return v;
      }
    }, m.zIndex = v, m.immediateRender = t.immediateRender !== !1), P && (m.opacity = function(V) {
      return O[V].sd < 0 ? 0 : O[V].sd > 0 ? O[V].a.opacity : "+=0";
    }), ne.length) {
      L = oe.utils.distribute(L);
      var Ln = le.slice(ne.length);
      m.stagger = function(V, Wt) {
        return L(~ne.indexOf(Wt) ? le.indexOf(O[V].swap.t) : V, Wt, Ln);
      };
    }
    if (Ii.forEach(function(V) {
      return t[V] && x.eventCallback(V, t[V], t[V + "Params"]);
    }), d && le.length) {
      y = Ae(m, Zt), "scale" in d && (d.scaleX = d.scaleY = d.scale, delete d.scale);
      for (ee in d)
        Ie = Ae(d[ee], mn), Ie[ee] = m[ee], !("duration" in Ie) && "duration" in m && (Ie.duration = m.duration), Ie.stagger = m.stagger, qe.call(x, le, Ie, 0), delete y[ee];
    }
    (le.length || $.length || B.length) && (h && x.add(function() {
      return vt(Te, h, x._zTime < 0 ? "remove" : "add");
    }, 0) && !f && vt(Te, h, "add"), le.length && qe.call(x, le, y, 0)), en(u, B, x), en(a, $, x);
    var dt = Y && Y.timeline;
    dt && (dt.add(x, 0), Y._final.push(function() {
      return Kt(O, !s);
    })), R = x.duration(), x.call(function() {
      var V = x.time() >= R;
      V && !dt && Kt(O, !s), h && vt(Te, h, V ? "remove" : "add");
    });
  }, c && (r = O.filter(function(me) {
    return !me.sd && !me.a.isVisible && me.b.isVisible;
  }).map(function(me) {
    return me.a.element;
  })), Y) {
    var Nt;
    r && (Nt = Y._abs).push.apply(Nt, Qt(O, r)), Y._run.push(ut);
  } else
    r && wn(Qt(O, r)), ut();
  var ct = Y ? Y.timeline : x;
  return ct.revert = function() {
    return zt(ct, 1, 1);
  }, ct;
}, Pi = function l(e) {
  e.vars.onInterrupt && e.vars.onInterrupt.apply(e, e.vars.onInterruptParams || []), e.getChildren(!0, !1, !0).forEach(l);
}, zt = function(e, n, t) {
  if (e && e.progress() < 1 && (!e.paused() || t))
    return n && (Pi(e), n < 2 && e.progress(1), e.kill()), !0;
}, Ze = function(e) {
  for (var n = e.idLookup = {}, t = e.alt = {}, o = e.elementStates, i = o.length, s; i--; )
    s = o[i], n[s.id] ? t[s.id] = s : n[s.id] = s;
}, fe = /* @__PURE__ */ function() {
  function l(n, t, o) {
    if (this.props = t && t.props, this.simple = !!(t && t.simple), o)
      this.targets = In(n), this.elementStates = n, Ze(this);
    else {
      this.targets = ze(n);
      var i = t && (t.kill === !1 || t.batch && !t.kill);
      Y && !i && Y._kill.push(this), this.update(i || !!Y);
    }
  }
  var e = l.prototype;
  return e.update = function(t) {
    var o = this;
    return this.elementStates = this.targets.map(function(i) {
      return new Ee(i, o.props, o.simple);
    }), Ze(this), this.interrupt(t), this.recordInlineStyles(), this;
  }, e.clear = function() {
    return this.targets.length = this.elementStates.length = 0, Ze(this), this;
  }, e.fit = function(t, o, i) {
    for (var s = st(this.elementStates.slice(0), !1, !0), u = (t || this).idLookup, a = 0, r, c; a < s.length; a++)
      r = s[a], i && (r.matrix = he(r.element, !1, !1, !0)), c = u[r.id], c && Me(r, c, o, !0, 0, r), r.matrix = he(r.element, !1, !1, !0);
    return this;
  }, e.getProperty = function(t, o) {
    var i = this.getElementState(t) || ot;
    return (o in i ? i : i.props || ot)[o];
  }, e.add = function(t) {
    for (var o = t.targets.length, i = this.idLookup, s = this.alt, u, a, r; o--; )
      a = t.elementStates[o], r = i[a.id], r && (a.element === r.element || s[a.id] && s[a.id].element === a.element) ? (u = this.elementStates.indexOf(a.element === r.element ? r : s[a.id]), this.targets.splice(u, 1, t.targets[o]), this.elementStates.splice(u, 1, a)) : (this.targets.push(t.targets[o]), this.elementStates.push(a));
    return t.interrupted && (this.interrupted = !0), t.simple || (this.simple = !1), Ze(this), this;
  }, e.compare = function(t) {
    var o = t.idLookup, i = this.idLookup, s = [], u = [], a = [], r = [], c = [], d = t.alt, p = this.alt, f = function(S, _, m) {
      return (S.isVisible !== _.isVisible ? S.isVisible ? a : r : S.isVisible ? u : s).push(m) && c.push(m);
    }, g = function(S, _, m) {
      return c.indexOf(m) < 0 && f(S, _, m);
    }, C, k, h, E, v, F, P, L;
    for (h in o)
      v = d[h], F = p[h], C = v ? kn(t, this, h) : o[h], E = C.element, k = i[h], F ? (L = k.isVisible || !F.isVisible && E === k.element ? k : F, P = v && !C.isVisible && !v.isVisible && L.element === v.element ? v : C, P.isVisible && L.isVisible && P.element !== L.element ? ((P.isDifferent(L) ? u : s).push(P.element, L.element), c.push(P.element, L.element)) : f(P, L, P.element), v && P.element === v.element && (v = o[h]), g(P.element !== k.element && v ? v : P, k, k.element), g(v && v.element === F.element ? v : P, F, F.element), v && g(v, F.element === v.element ? F : k, v.element)) : (k ? k.isDifferent(C) ? f(C, k, E) : s.push(E) : a.push(E), v && g(v, k, v.element));
    for (h in i)
      o[h] || (r.push(i[h].element), p[h] && r.push(p[h].element));
    return {
      changed: u,
      unchanged: s,
      enter: a,
      leave: r
    };
  }, e.recordInlineStyles = function() {
    for (var t = lt[this.props] || rt, o = this.elementStates.length; o--; )
      Xe(this.elementStates[o], t);
  }, e.interrupt = function(t) {
    var o = this, i = [];
    this.targets.forEach(function(s) {
      var u = s._flip, a = zt(u, t ? 0 : 1);
      t && a && i.indexOf(u) < 0 && u.add(function() {
        return o.updateVisibility();
      }), a && i.push(u);
    }), !t && i.length && this.updateVisibility(), this.interrupted || (this.interrupted = !!i.length);
  }, e.updateVisibility = function() {
    this.elementStates.forEach(function(t) {
      var o = t.element.getBoundingClientRect();
      t.isVisible = !!(o.width || o.height || o.top || o.left), t.uncache = 1;
    });
  }, e.getElementState = function(t) {
    return this.elementStates[this.targets.indexOf(Ue(t))];
  }, e.makeAbsolute = function() {
    return st(this.elementStates.slice(0), !0, !0).map(Ft);
  }, l;
}(), Ee = /* @__PURE__ */ function() {
  function l(n, t, o) {
    this.element = n, this.update(t, o);
  }
  var e = l.prototype;
  return e.isDifferent = function(t) {
    var o = this.bounds, i = t.bounds;
    return o.top !== i.top || o.left !== i.left || o.width !== i.width || o.height !== i.height || !this.matrix.equals(t.matrix) || this.opacity !== t.opacity || this.props && t.props && JSON.stringify(this.props) !== JSON.stringify(t.props);
  }, e.update = function(t, o) {
    var i = this, s = i.element, u = oe.getProperty(s), a = oe.core.getCache(s), r = s.getBoundingClientRect(), c = s.getBBox && typeof s.getBBox == "function" && s.nodeName.toLowerCase() !== "svg" && s.getBBox(), d = o ? new Oe(1, 0, 0, 1, r.left + $t(), r.top + Dt()) : he(s, !1, !1, !0);
    i.getProp = u, i.element = s, i.id = Ci(s), i.matrix = d, i.cache = a, i.bounds = r, i.isVisible = !!(r.width || r.height || r.left || r.top), i.display = u("display"), i.position = u("position"), i.parent = s.parentNode, i.x = u("x"), i.y = u("y"), i.scaleX = a.scaleX, i.scaleY = a.scaleY, i.rotation = u("rotation"), i.skewX = u("skewX"), i.opacity = u("opacity"), i.width = c ? c.width : be(u("width", "px"), 0.04), i.height = c ? c.height : be(u("height", "px"), 0.04), t && Li(i, Mt[t] || bn(t)), i.ctm = s.getCTM && s.nodeName.toLowerCase() === "svg" && gn(s).inverse(), i.simple = o || $e(d.a) === 1 && !$e(d.b) && !$e(d.c) && $e(d.d) === 1, i.uncache = 0;
  }, l;
}(), Oi = /* @__PURE__ */ function() {
  function l(n, t) {
    this.vars = n, this.batch = t, this.states = [], this.timeline = t.timeline;
  }
  var e = l.prototype;
  return e.getStateById = function(t) {
    for (var o = this.states.length; o--; )
      if (this.states[o].idLookup[t])
        return this.states[o];
  }, e.kill = function() {
    this.batch.remove(this);
  }, l;
}(), Ei = /* @__PURE__ */ function() {
  function l(n) {
    this.id = n, this.actions = [], this._kill = [], this._final = [], this._abs = [], this._run = [], this.data = {}, this.state = new fe(), this.timeline = oe.timeline();
  }
  var e = l.prototype;
  return e.add = function(t) {
    var o = this.actions.filter(function(i) {
      return i.vars === t;
    });
    return o.length ? o[0] : (o = new Oi(typeof t == "function" ? {
      animate: t
    } : t, this), this.actions.push(o), o);
  }, e.remove = function(t) {
    var o = this.actions.indexOf(t);
    return o >= 0 && this.actions.splice(o, 1), this;
  }, e.getState = function(t) {
    var o = this, i = Y, s = Ye;
    return Y = this, this.state.clear(), this._kill.length = 0, this.actions.forEach(function(u) {
      u.vars.getState && (u.states.length = 0, Ye = u, u.state = u.vars.getState(u)), t && u.states.forEach(function(a) {
        return o.state.add(a);
      });
    }), Ye = s, Y = i, this.killConflicts(), this;
  }, e.animate = function() {
    var t = this, o = Y, i = this.timeline, s = this.actions.length, u, a;
    for (Y = this, i.clear(), this._abs.length = this._final.length = this._run.length = 0, this.actions.forEach(function(r) {
      r.vars.animate && r.vars.animate(r);
      var c = r.vars.onEnter, d = r.vars.onLeave, p = r.targets, f, g;
      p && p.length && (c || d) && (f = new fe(), r.states.forEach(function(C) {
        return f.add(C);
      }), g = f.compare(X.getState(p)), g.enter.length && c && c(g.enter), g.leave.length && d && d(g.leave));
    }), wn(this._abs), this._run.forEach(function(r) {
      return r();
    }), a = i.duration(), u = this._final.slice(0), i.add(function() {
      a <= i.time() && (u.forEach(function(r) {
        return r();
      }), Jt(t, "onComplete"));
    }), Y = o; s--; )
      this.actions[s].vars.once && this.actions[s].kill();
    return Jt(this, "onStart"), i.restart(), this;
  }, e.loadState = function(t) {
    t || (t = function() {
      return 0;
    });
    var o = [];
    return this.actions.forEach(function(i) {
      if (i.vars.loadState) {
        var s, u = function a(r) {
          r && (i.targets = r), s = o.indexOf(a), ~s && (o.splice(s, 1), o.length || t());
        };
        o.push(u), i.vars.loadState(u);
      }
    }), o.length || t(), this;
  }, e.setState = function() {
    return this.actions.forEach(function(t) {
      return t.targets = t.vars.setState && t.vars.setState(t);
    }), this;
  }, e.killConflicts = function(t) {
    return this.state.interrupt(t), this._kill.forEach(function(o) {
      return o.interrupt(t);
    }), this;
  }, e.run = function(t, o) {
    var i = this;
    return this !== Y && (t || this.getState(o), this.loadState(function() {
      i._killed || (i.setState(), i.animate());
    })), this;
  }, e.clear = function(t) {
    this.state.clear(), t || (this.actions.length = 0);
  }, e.getStateById = function(t) {
    for (var o = this.actions.length, i; o--; )
      if (i = this.actions[o].getStateById(t), i)
        return i;
    return this.state.idLookup[t] && this.state;
  }, e.kill = function() {
    this._killed = 1, this.clear(), delete xt[this.id];
  }, l;
}(), X = /* @__PURE__ */ function() {
  function l() {
  }
  return l.getState = function(n, t) {
    var o = mt(n, t);
    return Ye && Ye.states.push(o), t && t.batch && l.batch(t.batch).state.add(o), o;
  }, l.from = function(n, t) {
    return t = t || {}, "clearProps" in t || (t.clearProps = !0), wt(n, mt(t.targets || n.targets, {
      props: t.props || n.props,
      simple: t.simple,
      kill: !!t.kill
    }), t, -1);
  }, l.to = function(n, t) {
    return wt(n, mt(t.targets || n.targets, {
      props: t.props || n.props,
      simple: t.simple,
      kill: !!t.kill
    }), t, 1);
  }, l.fromTo = function(n, t, o) {
    return wt(n, t, o);
  }, l.fit = function(n, t, o) {
    var i = o ? Ae(o, mn) : {}, s = o || i, u = s.absolute, a = s.scale, r = s.getVars, c = s.props, d = s.runBackwards, p = s.onComplete, f = s.simple, g = o && o.fitChild && Ue(o.fitChild), C = Tt(t, c, f, n), k = Tt(n, 0, f, C), h = c ? lt[c] : rt;
    return c && yn(i, C.props), d && (Xe(k, h), "immediateRender" in i || (i.immediateRender = !0), i.onComplete = function() {
      Vt(k), p && p.apply(this, arguments);
    }), u && Ft(k, C), i = Me(k, C, a || g, c, g, i.duration || r ? i : 0), r ? i : i.duration ? oe.to(k.element, i) : null;
  }, l.makeAbsolute = function(n, t) {
    return (n instanceof fe ? n : new fe(n, t)).makeAbsolute();
  }, l.batch = function(n) {
    return n || (n = "default"), xt[n] || (xt[n] = new Ei(n));
  }, l.killFlipsOf = function(n, t) {
    (n instanceof fe ? n.targets : ze(n)).forEach(function(o) {
      return o && zt(o._flip, t !== !1 ? 1 : 2);
    });
  }, l.isFlipping = function(n) {
    var t = l.getByTarget(n);
    return !!t && t.isActive();
  }, l.getByTarget = function(n) {
    return (Ue(n) || ot)._flip;
  }, l.getElementState = function(n, t) {
    return new Ee(Ue(n), t);
  }, l.convertCoordinates = function(n, t, o) {
    var i = he(t, !0, !0).multiply(he(n));
    return o ? i.apply(o) : i;
  }, l.register = function(n) {
    if (ke = typeof document < "u" && document.body, ke) {
      oe = n, St(ke), ze = oe.utils.toArray, kt = oe.core.getStyleSaver;
      var t = oe.utils.snap(0.1);
      be = function(i, s) {
        return t(parseFloat(i) + s);
      };
    }
  }, l;
}();
X.version = "3.12.0";
typeof window < "u" && window.gsap && window.gsap.registerPlugin(X);
const Si = { class: "AffiliationList__list" }, Di = { class: "AffiliationList__name notranslate" }, $i = /* @__PURE__ */ se({
  __name: "AffiliationList",
  props: {
    affiliations: {}
  },
  setup(l) {
    const e = l;
    q.registerPlugin(X);
    const n = w(!1), t = w(null), o = w(null), i = () => {
      if (e.affiliations.length <= 2)
        return;
      n.value = !n.value;
      const a = t.value;
      if (!a)
        return;
      const r = a.querySelectorAll(".AffiliationList__item--visibility"), c = X.getState(a), d = X.getState(r), p = X.getState(o.value);
      n.value ? a.classList.remove("AffiliationList--hidden") : a.classList.add("AffiliationList--hidden");
      const f = {
        duration: 0.28,
        ease: "power2.inOut"
      };
      X.from(p, {
        ...f
      }), X.from(c, {
        ...f
      }), X.from(d, {
        nested: !1,
        scale: !0,
        ...f,
        onStart: () => {
          q.to(r, {
            opacity: n.value ? 1 : 0,
            duration: 0.28,
            delay: 0.14
          });
        }
      });
    }, s = z(() => n.value ? "View less" : "See more"), u = z(() => e.affiliations.length > 2);
    return (a, r) => (I(), D("div", {
      ref_key: "affiliationList",
      ref: t,
      class: U(["AffiliationList", { "AffiliationList--hidden": u.value }])
    }, [
      b("ul", Si, [
        (I(!0), D(we, null, ye(a.affiliations, (c, d) => (I(), D("li", {
          class: U(["AffiliationList__item", { "AffiliationList__item--visibility": d > 1 }]),
          key: `aff-${c.index}`
        }, [
          b("p", Di, [
            b("span", null, Q(c.index) + ".", 1),
            Pe(" " + Q(c.affiliations), 1)
          ])
        ], 2))), 128)),
        u.value ? (I(), D("button", {
          key: 0,
          ref_key: "button",
          ref: o,
          class: "AffiliationList__button",
          onClick: r[0] || (r[0] = (c) => i())
        }, Q(s.value), 513)) : Z("", !0)
      ])
    ], 2));
  }
});
const Ai = /* @__PURE__ */ b("span", { class: "PeopleList__spacer" }, null, -1), Bi = {
  key: 0,
  class: "PeopleList__onBehalfOf"
}, ss = /* @__PURE__ */ se({
  __name: "PeopleList",
  props: {
    peopleList: {},
    affiliations: {},
    onBehalfOf: {}
  },
  setup(l) {
    const e = l;
    q.registerPlugin(X);
    const n = w(!1), t = w(null), o = w(null), i = z(() => {
      const h = (E) => E.affiliationIndexes !== void 0;
      if (Array.isArray(e.affiliations) && e.affiliations.length) {
        if (!e.peopleList.length || !h(e.peopleList[0]))
          throw new Error(
            "If the affiliations property is defined the peopleList property must implement items of the interface IIndexedPerson"
          );
        return {
          people: e.peopleList,
          organizations: e.affiliations
        };
      }
      return Gn(e.peopleList);
    }), s = z(() => i.value.people), u = z(() => s.value[s.value.length - 1]), a = z(() => s.value.slice(0, -1) || []), r = z(() => i.value.organizations), c = z(() => a.value.length > 9), d = z(() => Math.min(a.value.length, 13) - 8), p = z(() => c.value ? a.value.length - 8 : 0), f = z(() => n.value ? "See less" : `+${p.value} more`), g = z(() => d.value < 1 ? "PeopleList__list--0" : "PeopleList__list--" + d.value), C = () => {
      var M, S;
      const h = t.value, E = o.value;
      if (!h || !E || !u)
        return;
      const v = X.getState(h), F = X.getState(h.querySelectorAll(".PeopleListItem")), P = X.getState(
        h.querySelector(".PeopleList__button")
      );
      n.value ? (M = t.value) == null || M.classList.remove("PeopleList__list--hidden") : (S = t.value) == null || S.classList.add("PeopleList__list--hidden");
      const L = {
        duration: p.value < 5 ? 0.3 : 0.4,
        ease: "power2.inOut",
        prune: !0
      };
      X.from(v, {
        absolute: !1,
        ...L
      }), X.from(P, {
        ...L
      }), X.from(F, {
        nested: !1,
        scale: !0,
        ...L
      });
    }, k = () => {
      n.value = !n.value, Je(() => {
        C();
      });
    };
    return (h, E) => (I(), D("div", {
      ref_key: "mainEl",
      ref: o,
      class: "PeopleList"
    }, [
      b("ul", {
        ref_key: "peopleListEl",
        ref: t,
        class: U(["PeopleList__list PeopleList__list--hidden", g.value])
      }, [
        (I(!0), D(we, null, ye(a.value, (v) => (I(), te(T(Xt), {
          key: v.loopUserId,
          "full-name": v.fullName,
          "user-id": v.loopUserId,
          symbols: v.symbols,
          "affiliation-indexes": v.affiliationIndexes
        }, null, 8, ["full-name", "user-id", "symbols", "affiliation-indexes"]))), 128)),
        c.value ? (I(), D("button", {
          key: 0,
          class: "PeopleList__button PeopleList__button--more",
          onClick: E[0] || (E[0] = (v) => k())
        }, Q(f.value), 1)) : Z("", !0),
        W(T(Xt), {
          class: "last-people",
          "full-name": u.value.fullName,
          "user-id": u.value.loopUserId,
          symbols: u.value.symbols,
          "affiliation-indexes": u.value.affiliationIndexes
        }, null, 8, ["full-name", "user-id", "symbols", "affiliation-indexes"]),
        Ai
      ], 2),
      h.onBehalfOf ? (I(), D("span", Bi, " On behalf of " + Q(h.onBehalfOf), 1)) : Z("", !0),
      W(T($i), { affiliations: r.value }, null, 8, ["affiliations"])
    ], 512));
  }
}), Mi = /* @__PURE__ */ b("p", { class: "CardRT2__partOf" }, "Part of a Research Topic", -1), Vi = { class: "CardRT2__wrap" }, Fi = { key: 0 }, zi = { key: 1 }, Ri = /* @__PURE__ */ b("div", { class: "CardRT2__wrap--line" }, null, -1), as = /* @__PURE__ */ se({
  __name: "CardRT2",
  props: {
    id: {},
    title: {},
    isOpenForSubmission: { type: Boolean },
    totalArticles: {},
    totalViews: {},
    link: {},
    heading: { default: "h3" }
  },
  setup(l) {
    const e = l, n = z(() => {
      const t = [];
      return e.totalViews && t.push({ value: e.totalViews, text: "views" }), e.totalArticles && t.push({ value: e.totalArticles, text: "articles" }), t;
    });
    return (t, o) => (I(), te(T(Rn), {
      link: t.link,
      class: "CardRT2"
    }, {
      body: re(() => [
        Mi,
        b("div", Vi, [
          W(T(Fn), {
            class: "CardRT2__title",
            title: t.title,
            heading: t.heading
          }, null, 8, ["title", "heading"]),
          t.isOpenForSubmission ? (I(), D("i", Fi, "  ")) : Z("", !0),
          t.isOpenForSubmission ? (I(), D("span", zi, "Submission open")) : Z("", !0),
          W(T(an), {
            metrics: n.value,
            thousandToK: !0
          }, null, 8, ["metrics"]),
          Ri
        ])
      ]),
      _: 1
    }, 8, ["link"]));
  }
});
function xn(l, e, n, t, o) {
  const i = w(null), s = w(null), u = w(!1), a = o || 10, r = () => {
    s.value && s.value.disconnect();
  }, c = () => {
    r(), p();
  }, d = () => {
    !(n != null && n.value) || u.value || (u.value = !0, c(), setTimeout(() => {
      c(), u.value = !1;
    }, 100));
  }, p = () => {
    const k = {
      root: t ? t.value : null,
      rootMargin: `${-a}px 0px 0px 0px`,
      threshold: [0, 0.25, 0.5, 0.75, 1]
    };
    s.value = new IntersectionObserver(g, k), l.value.forEach((h) => {
      var v;
      const E = document.getElementById(h[e]);
      E && ((v = s.value) == null || v.observe(E));
    });
  }, f = w(
    l.value.map((k) => ({
      id: k[e],
      ratio: 0,
      top: 0
    }))
  ), g = (k) => {
    n != null && n.value && k.forEach((h) => {
      const E = f.value.findIndex(
        (v) => v.id === h.target.id
      );
      E < 0 || (f.value[E] = {
        id: h.target.id,
        ratio: h.intersectionRatio,
        top: h.intersectionRect.top
      });
    });
  }, C = z(() => {
    const k = window.innerHeight / 2.5, h = f.value.filter((P) => P.ratio), E = h.filter(
      (P) => P.top === a
    );
    if (E.length > 0) {
      const P = E.filter((L) => L.ratio > 0.5).sort((L, M) => L.ratio - M.ratio);
      if (P.length > 0) {
        let L = P[0];
        return L ? L.id : "";
      }
    }
    if ((t == null ? void 0 : t.value) !== null) {
      if (h.length === 1)
        return h[0].id;
      const P = h.filter((L) => L.ratio === 1);
      if (P.length > 0) {
        let M = P.filter(
          (S) => S.top < k && S.top >= a
        ).sort((S, _) => S.top - _.top)[0];
        return M ? M.id : "";
      }
    }
    let F = h.filter(
      (P) => P.top < k && P.top >= a
    ).sort((P, L) => L.top - P.top)[0];
    return F ? F.id : "";
  });
  return K(
    () => C.value,
    () => {
      n != null && n.value && C.value.length > 0 && (i.value = C.value);
    }
  ), K(
    () => l.value,
    () => {
      l.value.forEach((k) => {
        const h = k[e];
        f.value.find((v) => v.id === h) || f.value.push({
          id: h,
          ratio: 0,
          top: 0
        });
      }), Je(() => {
        c();
      });
    }
  ), xe(() => {
    p(), t != null && t.value ? (t.value.addEventListener("scrollend", d), t.value.addEventListener("touchend", d)) : (window.addEventListener("scrollend", d), window.addEventListener("touchend", d)), setTimeout(() => c, 300);
  }), at(() => {
    r(), t != null && t.value ? (t.value.removeEventListener("scrollend", d), t.value.removeEventListener("touchend", d)) : (window.removeEventListener("scrollend", d), window.removeEventListener("touchend", d));
  }), {
    activeId: i
  };
}
function Rt(l) {
  const e = w(!1), n = () => {
    if (!l.value)
      return;
    const o = l.value.offsetHeight, i = l.value.scrollHeight;
    e.value = i > o;
  };
  let t = null;
  return xe(() => {
    !l.value || typeof window > "u" || (t = new ResizeObserver(() => {
      n();
    }), n(), t.observe(l.value));
  }), at(() => {
    t && t.disconnect();
  }), { hasScrollbar: e };
}
const Ni = {
  key: 0,
  class: "Outline__title"
}, Wi = /* @__PURE__ */ b("span", { class: "Outline__icon" }, null, -1), ji = { class: "Outline__list" }, Hi = ["href", "onClick", "data-event"], Yi = /* @__PURE__ */ b("span", null, null, -1), Ui = { class: "Outline__link__text" }, ls = /* @__PURE__ */ se({
  __name: "Outline",
  props: {
    items: { default: () => new Array() }
  },
  setup(l) {
    const e = l;
    q.registerPlugin(X);
    const n = w(0), t = w(null), o = w(null), i = w(null), s = w(null), u = w(!0), a = w(null), { hasScrollbar: r } = Rt(a), c = A("isDesktopApp"), d = A("emitter"), p = w(0), f = w(!1), g = w(!1), C = () => {
      if (typeof window > "u")
        return null;
      const y = document.querySelectorAll(".Outline__item")[n.value];
      return y || null;
    }, k = () => {
      if (g.value)
        return;
      const y = C();
      y && y.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start"
      });
    }, h = (y, B) => {
      var O;
      const $ = Math.abs(n.value - B);
      if (y) {
        const ne = ((O = document.getElementById(e.items[B].targetId)) == null ? void 0 : O.offsetTop) || 200, pe = window.scrollY, Re = Math.abs(ne - pe);
        return Math.min(2, Math.max(Re / 1e4, 0.24));
      } else
        return Math.max(Math.min(0.1 * $, 0.5), 0.2);
    }, E = (y, B = 100, $ = !1) => {
      if (g.value)
        return;
      u.value = !1, $ && (g.value = !0);
      const O = X.getState(t.value);
      n.value = y;
      const ne = C();
      t.value && ne && ne.insertBefore(t.value, ne.firstChild);
      const pe = h($, y);
      X.from(O, {
        duration: pe,
        ease: "linear",
        scale: !0,
        absolute: !1,
        transformOrigin: "left top",
        onComplete: () => {
          setTimeout(() => {
            u.value = !0, g.value = !1;
          }, B);
        }
      });
    }, v = (y, B, $) => {
      if (y.preventDefault(), c.value) {
        if (!u.value)
          return;
        E($, 100, !0), setTimeout(() => {
          var pe;
          const O = ((pe = document.getElementById(e.items[n.value].targetId)) == null ? void 0 : pe.offsetTop) || 200, ne = window.scrollY;
          Math.abs(O - ne) > 30 && E($, 100, !0);
        }, 300);
      }
      d.emit("go-to-id", B.targetId);
    }, F = () => {
      typeof window > "u" || e.items.forEach((y) => {
        document.getElementById(y.targetId) || console.warn(
          `The item "${y.text}" has no target element with id "${y.targetId}" inside of the article body.`
        );
      });
    }, P = () => {
      var B;
      if (!o.value)
        return;
      const y = c.value ? i.value : s.value;
      y && ((B = o.value.parentElement) == null || B.removeChild(o.value), y.appendChild(o.value));
    }, L = () => {
      const y = C();
      c.value && t.value && y && y.insertBefore(t.value, y.firstChild);
    }, M = () => {
      const { pause: y } = Vn(() => {
        typeof document > "u" || (s.value ? y() : (s.value = document.getElementById("outline-content"), s.value && P()));
      }, 200);
    }, S = z(() => {
      const y = u.value && !g.value;
      return !f.value && y;
    }), { activeId: _ } = xn(
      w(e.items),
      "targetId",
      S
    ), m = (y) => e.items.findIndex((B) => B.targetId === y);
    K(
      () => _.value,
      () => {
        if (!_.value || g.value)
          return;
        const y = m(_.value);
        if (y > -1 && y !== n.value) {
          const $ = Math.abs(y - n.value) === 1 ? 0 : h(!0, y);
          setTimeout(() => {
            g.value || (E(y, 0), n.value = y, k());
          }, $);
        }
      }
    ), K(
      () => c.value,
      () => {
        P(), c.value && E(n.value, 100);
      }
    );
    const x = (y) => {
      f.value = y, !(!y || c.value) && (k(), setTimeout(() => {
        k();
      }, 300));
    };
    return xe(() => {
      M(), Je(() => {
        L(), F(), p.value = 1;
      });
      const y = window.location.hash.substring(1), B = e.items.findIndex(($) => $.targetId === y);
      if (B !== n.value && B > -1) {
        const $ = h(!0, n.value);
        setTimeout(() => k(), $ * 1e3);
      }
      d.on("is-open-side-panel", x);
    }), at(() => {
      d.off("is-open-side-panel", x);
    }), (y, B) => (I(), D("div", {
      ref_key: "wrapperDesktopEl",
      ref: i,
      id: "outline-desktop-wrapper",
      class: "OutlineWrapper"
    }, [
      b("div", {
        ref_key: "outlineEl",
        ref: o,
        class: U(["Outline", { "Outline--scrollbar": T(r) }])
      }, [
        T(c) ? (I(), D("p", Ni, [
          Wi,
          Pe("Outline ")
        ])) : Z("", !0),
        b("nav", {
          ref_key: "navEl",
          ref: a,
          class: "Outline__nav"
        }, [
          b("ul", ji, [
            (I(!0), D(we, null, ye(y.items, ($, O) => (I(), D("li", {
              key: $.targetId,
              class: U(["Outline__item", { "Outline__item--active": O === n.value }])
            }, [
              b("a", {
                href: `#${$.targetId}`,
                class: U(["Outline__link", { "Outline__link--active": O === n.value }]),
                onClick: (ne) => v(ne, $, O),
                "data-event": y.$ga.getDataEventValue("OutlineItem", "a", $.targetId)
              }, [
                Yi,
                b("p", Ui, Q($.text), 1)
              ], 10, Hi)
            ], 2))), 128))
          ]),
          b("div", {
            ref_key: "activeBgEl",
            ref: t,
            class: "Outline__activeBg",
            style: Cn({ opacity: p.value })
          }, null, 4)
        ], 512)
      ], 2)
    ], 512));
  }
}), Xi = { class: "FiguresOutlineItem" }, Ji = { class: "FiguresOutlineItem__title" }, qi = ["data-event"], Gi = ["data-event"], Zi = { class: "FiguresOutlineItem__table__icon" }, Ki = { class: "FiguresOutlineItem__table__description" }, Qi = ["href", "aria-label", "data-event"], eo = /* @__PURE__ */ se({
  __name: "FiguresOutlineItem",
  props: {
    index: {},
    title: {},
    targetId: {},
    image: {},
    description: {},
    downloadUrl: {}
  },
  emits: ["figure-on-click"],
  setup(l, { emit: e }) {
    const n = l, t = A("emitter"), o = () => {
      e("figure-on-click", n.index), t.emit("close-info-drawer");
    }, i = (u, a) => {
      u.preventDefault(), t.emit("go-to-id", a);
    }, s = z(() => `View ${n.title} in article`);
    return (u, a) => (I(), D("li", Xi, [
      b("p", Ji, Q(u.title), 1),
      u.image ? (I(), D("button", {
        key: 0,
        class: "FiguresOutlineItem__image",
        onClick: o,
        "data-event": u.$ga.getDataEventValue("FigureOutline", "button", "openLightbox")
      }, [
        W(T(Lt), {
          class: "FiguresOutlineItem__image",
          sources: u.image.sources,
          "image-alt": u.image.imageAlt,
          "lazy-loading-attr": !0
        }, null, 8, ["sources", "image-alt"]),
        W(T(jt), {
          fill: "var(--maincolor50)",
          size: "lg"
        })
      ], 8, qi)) : (I(), D("button", {
        key: 1,
        class: "FiguresOutlineItem__table",
        onClick: o,
        "data-event": u.$ga.getDataEventValue("FigureOutline", "button", "openTable")
      }, [
        b("div", Zi, [
          W(T(jt), { size: "lg" })
        ]),
        b("p", Ki, Q(n.description), 1)
      ], 8, Gi)),
      b("a", {
        href: `#${u.targetId}`,
        class: "FiguresOutlineItem__link",
        "aria-label": s.value,
        onClick: a[0] || (a[0] = (r) => i(r, u.targetId)),
        "data-event": u.$ga.getDataEventValue("FigureOutline", "a", "viewInArticle")
      }, [
        W(T(Nn)),
        Pe("View in article")
      ], 8, Qi)
    ]));
  }
});
const to = { class: "FiguresOutline__title" }, rs = /* @__PURE__ */ se({
  __name: "FiguresOutline",
  props: {
    figures: {}
  },
  emits: ["figure-on-click"],
  setup(l, { emit: e }) {
    const n = (c) => {
      e("figure-on-click", c);
    }, t = w(null), { hasScrollbar: o } = Rt(t), i = w(null), s = w(null), u = w(null), a = A("isDesktopApp"), r = () => {
      var c, d;
      a.value ? (c = s.value) == null || c.appendChild(i.value) : (d = u.value) == null || d.appendChild(i.value);
    };
    return K(
      () => a.value,
      () => {
        r();
      }
    ), xe(() => {
      u.value = document.getElementById("figures-content"), r();
    }), (c, d) => (I(), D("div", {
      ref_key: "wrapperDesktopEl",
      ref: s,
      id: "figures-desktop-wrapper",
      class: "FiguresOutlineWrapper"
    }, [
      c.figures ? (I(), D("div", {
        key: 0,
        ref_key: "figuresEl",
        ref: i,
        class: U(["FiguresOutline", { "FiguresOutline--scrollbar": T(o) }])
      }, [
        b("div", to, [
          W(T(Wn), { size: "md" }),
          Pe("Figures and Tables ")
        ]),
        b("ul", {
          class: "FiguresOutline__list",
          ref_key: "navEl",
          ref: t
        }, [
          (I(!0), D(we, null, ye(c.figures, (p, f) => (I(), te(T(eo), {
            key: f,
            title: p.title,
            targetId: p.targetId,
            image: p.image ? p.image : void 0,
            description: p.description,
            index: f,
            onFigureOnClick: n
          }, null, 8, ["title", "targetId", "image", "description", "index"]))), 128))
        ], 512)
      ], 2)) : Z("", !0)
    ], 512));
  }
}), no = { class: "Lightbox__grid" }, io = { class: "Lightbox__title" }, oo = ["data-event"], so = /* @__PURE__ */ b("div", { class: "Lightbox__spacer" }, null, -1), ao = { class: "Lightbox__range Lightbox--hiddenDevices" }, lo = { class: "Lightbox__wrapper" }, ro = { class: "Lightbox__info" }, uo = ["data-event"], co = { class: "Lightbox__description" }, fo = { class: "Lightbox__footerNav" }, po = ["data-event"], ho = /* @__PURE__ */ b("span", null, "Previous", -1), vo = [
  ho
], go = ["data-event"], mo = /* @__PURE__ */ b("span", null, "Next", -1), _o = [
  mo
], Ke = 4, We = 1, bo = 200, us = /* @__PURE__ */ se({
  __name: "Lightbox",
  props: {
    items: { default: () => new Array() },
    isOpen: { type: Boolean, default: !1 },
    currentIndex: { default: 0 }
  },
  emits: ["close", "download-image", "go-to-id"],
  setup(l, { emit: e }) {
    const n = l;
    Pn((R) => ({
      a406be6e: M.value
    }));
    const t = A("emitter"), o = rn, i = w(0), s = w(null), u = w(null), a = w(null), r = w(null), c = w(1), d = w(!0), p = w(null), f = A("isDesktopApp"), { isSwiping: g, direction: C } = sn(p), k = w(!1), h = w(!1), E = w(!0), v = z(() => n.items[i.value]), F = z(() => {
      var j;
      return (((j = n.items[i.value].image) == null ? void 0 : j.sources) || [])[0].src;
    }), P = z(() => i.value <= 0), L = z(() => i.value >= n.items.length - 1), M = z(() => `${(c.value - We) * 100 / (Ke - We)}%`);
    z(() => E.value ? "Hide caption" : "Show caption");
    const S = () => {
      P.value || (i.value -= 1, m(), ee());
    }, _ = () => {
      L.value || (i.value += 1, m(), ee());
    }, m = () => {
      var j;
      u.value && (u.value.innerHTML = "");
      const R = (j = a.value) == null ? void 0 : j.querySelector(".ArticleTable__foot");
      R && R.remove();
    }, x = () => {
      h.value = !1, r.value = null, m(), e("close");
    }, y = () => {
      E.value = !E.value, a.value && ft.to(a.value, {
        onStart: () => {
          ft.set(a.value, { overflow: "hidden" });
        },
        height: E.value ? "auto" : 0,
        duration: 0.24,
        ease: "power2.inOut",
        onComplete: () => {
          ft.set(a.value, { overflow: "auto" });
        }
      });
    }, B = (R, j) => {
      R.preventDefault(), x(), setTimeout(() => {
        t.emit("go-to-id", j);
      }, 200);
    }, $ = z(() => n.items[i.value].downloadUrl || ""), O = async () => {
      fetch($.value, { headers: {} }).then((R) => R.blob()).then((R) => {
        const j = URL.createObjectURL(R);
        Object.assign(document.createElement("a"), {
          href: j,
          download: $.value
        }).click(), URL.revokeObjectURL(j), e("download-image", !0);
      }).catch(() => e("download-image", !1));
    }, ne = {
      step: 0.25,
      minScale: We,
      maxScale: Ke,
      duration: bo,
      roundPixels: !0,
      pinchAndPan: !0
    }, pe = () => {
      h.value = !1, r.value = null, c.value = 1;
      const R = new Image();
      R.src = F.value, R.onload = () => {
        var le, Se;
        if (!s.value)
          return;
        const j = ((le = s.value) == null ? void 0 : le.offsetHeight) / ((Se = s.value) == null ? void 0 : Se.offsetWidth), H = R.height / R.width;
        if (d.value = R.width > R.height && j > H, !s.value)
          return;
        const N = s.value.querySelector(
          ".FrontiersImage .FrontiersImage"
        );
        r.value = Xn(N, ne);
        const ce = setInterval(() => {
          r.value && (setTimeout(() => {
            h.value = !0;
          }, 100), clearInterval(ce));
        }, 50);
      };
    }, Re = () => {
      r.value && (r.value.zoomIn(), c.value = r.value.getScale());
    }, Ne = () => {
      r.value && (r.value.zoomOut(), c.value = r.value.getScale());
    }, qe = () => {
      r.value && r.value.zoom(c.value);
    }, Ie = () => {
      var R, j;
      if (!v.value.image) {
        u.value && (u.value.innerHTML = "");
        const H = document.getElementById(v.value.targetId);
        if (!H)
          return;
        const N = H.cloneNode(!0);
        (R = u.value) == null || R.appendChild(N);
        const ce = N.querySelector(
          ".ArticleTable__foot"
        );
        ce && ((j = a.value) == null || j.appendChild(ce));
      }
    }, ee = () => {
      v.value.image ? pe() : setTimeout(() => {
        Ie();
      }, 0);
    };
    return K(
      () => n.isOpen,
      () => {
        i.value = n.currentIndex, n.isOpen && ee();
      }
    ), K(g, () => {
      f.value || (C.value === "up" ? k.value = !0 : C.value === "down" && (k.value = !1));
    }), at(() => {
      r.value && r.value.destroy();
    }), (R, j) => {
      var H;
      return Ve((I(), D("div", {
        class: U([{ "Lightbox--open": R.isOpen }, "Lightbox"])
      }, [
        b("button", {
          "aria-label": "Close view",
          class: "Lightbox__overlay",
          onClick: x
        }),
        b("div", no, [
          b("div", {
            class: U(["Lightbox__main", { "Lightbox__main--expanded": k.value }])
          }, [
            b("div", {
              ref_key: "headerMobile",
              ref: p,
              class: "Lightbox__header"
            }, [
              b("p", io, Q(v.value.title), 1),
              b("button", {
                class: "Lightbox__article",
                "data-event": R.$ga.getDataEventValue("Lightbox", "button", "viewInArticle"),
                onClick: j[0] || (j[0] = (N) => B(N, v.value.targetId))
              }, " View in article ", 8, oo),
              so,
              v.value.image ? (I(), D(we, { key: 0 }, [
                W(T(De), {
                  class: "Lightbox--hiddenDevices",
                  color: "Black",
                  size: "Large",
                  label: "Zoom out",
                  "is-disabled": c.value <= We,
                  "show-tooltip": !0,
                  "tooltip-position": ["bottom", "center"],
                  "data-event": R.$ga.getDataEventValue("Lightbox", "button", "zoomOut"),
                  onClick: Ne
                }, {
                  default: re(() => [
                    W(T(jn), { size: "lg" })
                  ]),
                  _: 1
                }, 8, ["is-disabled", "data-event"]),
                b("div", ao, [
                  Ve(b("input", {
                    ref: "rangeEl",
                    "onUpdate:modelValue": j[1] || (j[1] = (N) => c.value = N),
                    max: Ke,
                    min: We,
                    step: "0.1",
                    type: "range",
                    onInput: qe
                  }, null, 544), [
                    [
                      On,
                      c.value,
                      void 0,
                      { number: !0 }
                    ]
                  ])
                ]),
                W(T(De), {
                  class: "Lightbox--hiddenDevices",
                  color: "Black",
                  size: "Large",
                  label: "Zoom in",
                  "is-disabled": c.value >= Ke,
                  "show-tooltip": !0,
                  "tooltip-position": ["bottom", "center"],
                  "data-event": R.$ga.getDataEventValue("Lightbox", "button", "zoomIn"),
                  onClick: Re
                }, {
                  default: re(() => [
                    W(T(Hn), { size: "lg" })
                  ]),
                  _: 1
                }, 8, ["is-disabled", "data-event"]),
                W(T(De), {
                  color: "Black",
                  size: "Large",
                  label: "Download figure",
                  "show-tooltip": !0,
                  "tooltip-position": ["bottom", "center"],
                  "data-event": R.$ga.getDataEventValue("Lightbox", "button", "downloadImage"),
                  onClick: O
                }, {
                  default: re(() => [
                    W(T(ln), { size: "lg" })
                  ]),
                  _: 1
                }, 8, ["data-event"])
              ], 64)) : Z("", !0),
              W(T(De), {
                color: "Black",
                size: "Large",
                label: "Close view",
                "show-tooltip": !0,
                "tooltip-position": ["bottom", "center"],
                "data-event": R.$ga.getDataEventValue("Lightbox", "button", "close"),
                onClick: x
              }, {
                default: re(() => [
                  W(T(Yn), { size: "lg" })
                ]),
                _: 1
              }, 8, ["data-event"])
            ], 512),
            b("div", lo, [
              v.value.image ? (I(), D("div", {
                key: 0,
                ref_key: "wrapperEl",
                ref: s,
                class: U([{
                  "Lightbox__mask--landscape": d.value,
                  "Lightbox__mask--hidden": !h.value
                }, "Lightbox__mask"])
              }, [
                W(T(Lt), En(Sn(v.value.image)), null, 16)
              ], 2)) : (I(), D("div", {
                key: 1,
                ref_key: "tableEl",
                ref: u,
                class: "Lightbox__table"
              }, null, 512)),
              b("div", ro, [
                (H = v.value.description) != null && H.length ? (I(), D("button", {
                  key: 0,
                  class: "Lightbox__info__trigger",
                  "data-event": R.$ga.getDataEventValue("Lightbox", "button", "toggleCaption"),
                  onClick: y
                }, [
                  b("div", {
                    class: U(["Lightbox__info__trigger__caption", {
                      "Lightbox__info__trigger__caption--hidden": !E.value
                    }])
                  }, " Caption ", 2)
                ], 8, uo)) : Z("", !0),
                b("div", {
                  ref_key: "infoEl",
                  ref: a,
                  class: U(["Lightbox__info__scroll", { "Lightbox__info__scroll--expanded": k.value }])
                }, [
                  b("p", co, Q(v.value.description), 1)
                ], 2)
              ]),
              b("div", fo, [
                b("button", {
                  class: U(["Lightbox__nav Lightbox__nav--prev", { "Lightbox__nav--disabled": P.value }]),
                  "data-event": R.$ga.getDataEventValue("Lightbox", "button", "previous"),
                  onClick: S
                }, vo, 10, po),
                b("button", {
                  class: U(["Lightbox__nav Lightbox__nav--next", { "Lightbox__nav--disabled": L.value }]),
                  "data-event": R.$ga.getDataEventValue("Lightbox", "button", "next"),
                  onClick: _
                }, _o, 10, go)
              ])
            ])
          ], 2)
        ])
      ], 2)), [
        [
          T(o),
          R.isOpen,
          void 0,
          { noDelay: !0 }
        ]
      ]);
    };
  }
}), wo = ["tab"], yo = ["data-event", "href"], Io = { class: "ToolbarItem__text" }, ko = /* @__PURE__ */ se({
  __name: "ToolbarItem",
  props: {
    tab: {}
  },
  setup(l) {
    const e = l, n = A("emitter"), t = A("isOpenSidePanel"), o = A("animations"), i = A("tabs"), s = A("activeTab"), u = A("isClickingOnTab"), a = A("isChangingTab"), r = A("isDesktopApp"), c = A("goToTab"), d = Ct();
    c.value = (f) => {
      if (!i.value.some(
        (C) => {
          var k;
          return C.targetId === f || ((k = s.value) == null ? void 0 : k.targetId);
        }
      )) {
        console.warn(`Tab with id ${f} does not exist`);
        return;
      }
      if (a.value = !0, !t.value) {
        t.value = !0;
        const C = r.value ? 0 : 100;
        setTimeout(o.showSidePanel, C);
      }
      u.value = !0, f ? (s.value = un(i.value, f), f === "outline" && n.emit("open-outline-id")) : s.value && (window.location.hash = s.value.targetId), setTimeout(() => {
        a.value = !1;
      }, d + 100);
    };
    const p = z(() => s.value ? e.tab.targetId === s.value.targetId && !a.value && r.value : !1);
    return (f, g) => Ve((I(), D("li", {
      class: "ToolbarItem",
      tab: f.tab.targetId
    }, [
      b("a", {
        class: U([{
          "ToolbarItem__action--active": p.value
        }, "ToolbarItem__action"]),
        "data-event": f.$ga.getDataEventValue("InfoDrawer", "a", f.tab.targetId),
        href: `#${f.tab.targetId}`,
        onClick: g[0] || (g[0] = (C) => T(c)(f.tab.targetId))
      }, [
        (I(), te(de(T(Fe)(f.tab.icon)), { size: "lg" })),
        b("span", Io, Q(f.tab.titleToolbar), 1)
      ], 10, yo)
    ], 8, wo)), [
      [nn, !f.tab.isHiddenMobile]
    ]);
  }
});
const xo = ["href", "target", "rel", "data-event", "onClick"], To = ["data-event", "onClick"], Tn = /* @__PURE__ */ se({
  __name: "ToolbarContextual",
  props: {
    items: {},
    isOpen: { type: Boolean, default: !1 },
    showActive: { type: Boolean, default: !1 },
    isUp: { type: Boolean, default: !1 }
  },
  emits: ["updated"],
  setup(l, { emit: e }) {
    const n = l, t = w(n.items[0]), o = z(() => n.showActive ? n.items : n.items.filter((i) => i.label !== t.value.label));
    return (i, s) => (I(), D("ul", {
      class: U(["ToolbarContextual", {
        "ToolbarContextual--open": i.isOpen,
        "ToolbarContextual--up": i.isUp
      }])
    }, [
      (I(!0), D(we, null, ye(o.value, (u) => (I(), D("li", {
        key: u.label,
        class: "ToolbarContextual__option"
      }, [
        u.href ? (I(), D("a", {
          key: 0,
          href: u.href,
          target: u.target || "_self",
          rel: u.rel || "",
          class: "ToolbarContextual__btn",
          "data-event": i.$ga.getDataEventValue("toolbarContextual", u.label),
          onClick: (a) => e("updated", u)
        }, [
          (I(), te(de(T(Fe)(u.icon)), { size: "md" })),
          b("span", null, Q(u.label), 1)
        ], 8, xo)) : (I(), D("button", {
          key: 1,
          class: "ToolbarContextual__btn",
          "data-event": i.$ga.getDataEventValue("toolbarContextual", u.label),
          onClick: (a) => e("updated", u)
        }, [
          (I(), te(de(T(Fe)(u.icon)), { size: "md" })),
          b("span", null, Q(u.label), 1)
        ], 8, To))
      ]))), 128))
    ], 2));
  }
});
const Lo = { class: "ToolbarDownload" }, Co = ["data-event", "href", "target"], Po = { class: "ToolbarDownload__wrapper" }, Oo = /* @__PURE__ */ b("p", { class: "ToolbarDownload__text" }, "PDF", -1), Eo = { class: "ToolbarDownload__format" }, So = {
  key: 0,
  class: "TooltipD TooltipD--bottom TooltipD--right"
}, Do = /* @__PURE__ */ se({
  __name: "ToolbarDownload",
  setup(l) {
    const e = w(!1), n = w(!1), t = w(null), o = A("isDesktopApp"), i = A("downloadItems"), s = w(i[0]), u = A("emitter"), a = z(() => i.map((g) => ({
      key: g.key,
      label: g.label,
      icon: "DownloadIcon",
      href: g.href,
      target: g.target,
      rel: "noopener noreferrer"
    }))), r = () => {
      u.emit("article-download", s.value);
    }, c = () => {
      n.value = !0, e.value = !e.value;
    }, d = () => {
      e.value = !1;
    }, p = () => {
      n.value = !1;
    }, f = (g) => {
      s.value = i.find(
        (C) => C.label === g.label
      ), e.value = !1, r();
    };
    return Dn(() => {
      o.value || (s.value = i.find(
        (g) => g.label === a.value[0].label
      ));
    }), (g, C) => (I(), D("li", Lo, [
      b("a", {
        ref_key: "linkDownload",
        ref: t,
        "data-event": g.$ga.getDataEventValue("Download", "a", s.value.label),
        href: s.value.href,
        class: "ToolbarDownload__action",
        rel: "noopener noreferrer",
        target: s.value.target,
        onClick: r
      }, [
        b("div", Po, [
          W(T(ln), {
            fill: "white",
            size: "lg"
          })
        ]),
        Oo
      ], 8, Co),
      W(T(cn), { onTrigger: d }, {
        default: re(() => [
          b("div", Eo, [
            b("button", {
              class: U(["ToolbarDownload__format__trigger", {
                "ToolbarDownload__format__trigger--open": e.value
              }]),
              onClick: c,
              onMouseleave: p
            }, [
              !n.value && !e.value ? (I(), D("p", So, " Download other format ")) : Z("", !0),
              W(T(Un), { size: "md" })
            ], 34),
            W(Tn, {
              items: a.value,
              "is-open": e.value,
              onUpdated: f
            }, null, 8, ["items", "is-open"])
          ])
        ]),
        _: 1
      })
    ]));
  }
});
const $o = {
  key: 1,
  class: "ToolbarItem ToolbarItem--more"
}, Ao = ["data-event"], Bo = /* @__PURE__ */ b("span", { class: "ToolbarItem__text" }, "More", -1), Mo = /* @__PURE__ */ se({
  __name: "Toolbar",
  emits: ["download"],
  setup(l, { emit: e }) {
    q.registerPlugin(Yt);
    const n = A("toolbar"), t = A("tabs"), o = A("isDesktopApp"), i = A("isResizingBody"), s = A("activeTab"), u = A("isOpenMoreOptions"), a = A("isOpenSidePanel"), r = A("goToTab"), c = A("hasDownload"), d = w(t.value.length - 1), p = w([]), f = w(!0), g = () => {
      u.value = !u.value;
    }, C = () => {
      t.value.forEach((L) => {
        L.isHiddenMobile = !1;
      }), d.value = t.value.length - 1, f.value = !0, p.value = [];
    }, k = () => {
      if (!n.value || t.value.length - p.value.length <= 1)
        return;
      n.value.scrollWidth > n.value.clientWidth ? (t.value[d.value].isHiddenMobile = !0, p.value.push(t.value[d.value]), d.value--, setTimeout(() => {
        k();
      }, 0)) : setTimeout(() => {
        f.value = p.value.length > 0, q.set(n.value, { opacity: 1 });
      }, 0);
    }, h = () => {
      C(), Je(() => {
        o.value || k();
      });
    }, E = z(() => p.value.map((M, S) => ({
      key: "showMoreItem-" + S,
      label: M.titleToolbar,
      icon: M.icon
    })).reverse()), v = (L) => {
      const M = t.value.find((S) => S.titleToolbar === L.label);
      M && (s.value = M, r.value()), F();
    }, F = () => {
      u.value = !1;
    }, P = () => {
      Yt.create({
        trigger: "body",
        start: "top -11",
        end: "top -11",
        markers: !1,
        scrub: !0,
        onEnter: () => {
          parseInt(
            document.body.getAttribute("data-scroll-top") || "0"
          ) > 10 && window.scrollY === 0 || o.value && q.to(n.value, {
            top: 96,
            duration: 0.3,
            ease: "power2.out"
          });
        },
        onEnterBack: () => {
          parseInt(
            document.body.getAttribute("data-scroll-top") || "0"
          ) > 10 && window.scrollY === 0 || o.value && q.to(n.value, {
            top: 96 + 48,
            duration: 0.3,
            ease: "power2.out"
          });
        }
      });
    };
    return K(
      () => t.value,
      () => {
        setTimeout(() => {
          o.value || h();
        }, 1);
      }
    ), K(
      () => i.value,
      () => {
        h();
      }
    ), xe(() => {
      h(), P();
    }), (L, M) => (I(), D("nav", {
      ref_key: "toolbar",
      ref: n,
      class: "Toolbar"
    }, [
      b("ul", {
        class: U(["Toolbar__list", { "Toolbar__list--withSidepanel": T(a) }])
      }, [
        T(c) ? (I(), te(Do, { key: 0 })) : Z("", !0),
        (I(!0), D(we, null, ye(T(t), (S) => (I(), te(ko, {
          key: S.targetId,
          tab: S
        }, null, 8, ["tab"]))), 128)),
        f.value && T(t).length > 2 ? (I(), D("li", $o, [
          b("a", {
            "data-event": L.$ga.getDataEventValue("InfoDrawer", "a", "moreOptions"),
            class: "ToolbarItem__action",
            onClick: g
          }, [
            (I(), te(de(T(Fe)("MoreOptionsVerticalIcon")), { size: "lg" })),
            Bo
          ], 8, Ao),
          W(T(cn), { onTrigger: F }, {
            default: re(() => [
              W(Tn, {
                items: E.value,
                "is-open": T(u),
                "show-active": !0,
                "is-up": !0,
                onUpdated: v
              }, null, 8, ["items", "is-open"])
            ]),
            _: 1
          })
        ])) : Z("", !0)
      ], 2)
    ], 512));
  }
});
const Vo = { class: "SidePanelID__close" }, Fo = {
  key: 0,
  class: "SidePanelID__title"
}, zo = ["id"], Ro = ["id"], No = /* @__PURE__ */ se({
  __name: "SidePanelID",
  setup(l) {
    const e = rn, n = A("sidePanel"), t = A("isOpenSidePanel"), o = A("closeSidePanel"), i = A("activeTab"), s = A("isClickingOnTab"), u = A("isChangingTab"), a = A("tabs"), r = A("isDesktopApp"), c = A("animations"), d = A("isOpenMoreOptions"), p = A("heading"), f = w(null), { isSwiping: g, direction: C } = sn(f), k = w(!1), h = w(null), { hasScrollbar: E } = Rt(h), v = Ct(), F = (S) => {
      var _;
      return r.value ? !0 : ((_ = i.value) == null ? void 0 : _.targetId) === S;
    }, P = () => {
      o(), setTimeout(() => {
        k.value = !1;
      }, v);
    }, L = () => {
      const S = h.value;
      if (S)
        if (t.value) {
          if (!i.value)
            return;
          const _ = document.getElementById(i.value.targetId);
          if (!h.value || !_) {
            _ || console.warn(
              `SidePanel content for tab ${i.value.targetId} not found`
            );
            return;
          }
          S.scrollTo({
            top: _.offsetTop
          }), setTimeout(() => {
            s.value = !1;
          }, v), S.style.scrollBehavior = "smooth";
        } else
          setTimeout(() => {
            S.style.scrollBehavior = "auto", S.scrollTo({
              top: 0
            });
          }, v);
    };
    K(
      () => t.value,
      () => {
        L();
      }
    ), K(g, () => {
      C.value === "up" ? (k.value = !0, c.toogleExpandSP(!0)) : C.value === "down" && (P(), d.value = !1);
    });
    const { activeId: M } = xn(
      a,
      "targetId",
      t,
      h,
      -54
    );
    return K(M, () => {
      if (M.value && !u.value) {
        const S = a.value.find((_) => _.targetId === M.value);
        S && (i.value = S);
      }
    }), xe(() => {
      L();
    }), (S, _) => {
      var m;
      return Ve((I(), D("div", {
        ref_key: "sidePanel",
        ref: n,
        class: "SidePanelID"
      }, [
        b("div", Vo, [
          W(T(De), {
            color: "Black",
            size: "Medium",
            label: "Close the panel",
            "data-event": S.$ga.getDataEventValue("SidePanelID", "button", "close"),
            icon: "Close",
            onClick: P
          }, null, 8, ["data-event"])
        ]),
        b("div", {
          ref_key: "headerMobile",
          ref: f,
          class: "SidePanelID__headerMobile"
        }, [
          T(i) ? (I(), D("p", Fo, [
            (I(), te(de(T(Fe)(T(i).icon)), {
              fill: "black",
              size: "md"
            })),
            Pe(" " + Q(T(i).title), 1)
          ])) : Z("", !0),
          W(T(De), {
            color: "Black",
            size: "Small",
            label: "Close the panel",
            "data-event": S.$ga.getDataEventValue("SidePanelID", "button", "close"),
            icon: "Close",
            onClick: T(o)
          }, null, 8, ["data-event", "onClick"])
        ], 512),
        b("div", {
          ref_key: "body",
          ref: h,
          class: U(`SidePanelID__body SidePanelID__body--${(m = T(i)) == null ? void 0 : m.targetId}`)
        }, [
          (I(!0), D(we, null, ye(T(a), (x) => (I(), D("div", {
            id: x.targetId,
            key: x.targetId,
            class: "SidePanelID__section"
          }, [
            Ve(b("div", {
              class: U(["SidePanelID__wrapper", { "SidePanelID__wrapper--scrollbar": T(E) }])
            }, [
              T(r) ? (I(), te(de(T(p)), {
                key: 0,
                class: "SidePanelID__title"
              }, {
                default: re(() => [
                  (I(), te(de(T(Fe)(x.icon)), {
                    fill: "black",
                    size: "lg"
                  })),
                  Pe(" " + Q(x.title), 1)
                ]),
                _: 2
              }, 1024)) : Z("", !0),
              b("div", {
                class: "SidePanelID__content",
                id: `${x.targetId}-content`
              }, [
                on(S.$slots, x.targetId)
              ], 8, Ro)
            ], 2), [
              [nn, F(x.targetId)]
            ])
          ], 8, zo))), 128))
        ], 2)
      ])), [
        [
          T(e),
          T(t),
          void 0,
          { backDelayInfoDrawer: !0 }
        ]
      ]);
    };
  }
});
q.registerPlugin(X);
const G = {
  easeIn: "power1.in",
  easeOut: "power1.out",
  easeInOut: "power1.in.out",
  toolbarOffset: 96,
  desktopBreakpoint: 1024
}, Wo = (l, e, n, t, o, i, s) => {
  const u = Jn(), a = w(!1), r = w(!1), c = () => window.innerWidth > G.desktopBreakpoint, d = () => i.value ? 0 : window.innerHeight / 3, p = () => i.value ? 1 : 0, f = () => {
    const m = o.value.getBoundingClientRect();
    return {
      width: m.width,
      rightPosition: window.innerWidth - m.left
    };
  }, g = (_, m = 1) => _ ? 0 : u * m, C = (_ = !1) => {
    a.value = _, c() ? E(_) : F(_), L(_);
  }, k = (_ = !1) => {
    a.value = _, c() ? v(_) : P(_), M(_);
  }, h = () => {
    if (!c())
      return;
    const { width: _ } = f(), m = g(!1, 1);
    q.set(e.value, { x: _ }), q.to(e.value, {
      y: d(),
      opacity: p(),
      duration: m,
      ease: "linear",
      onStart: () => {
        var x;
        i.value && ((x = e.value) == null || x.classList.remove("Toolbar--invisible"));
      },
      onComplete: () => {
        var x;
        !i.value && !s.value && ((x = e.value) == null || x.classList.add("Toolbar--invisible"));
      }
    });
  }, E = (_ = !1) => {
    var $;
    ($ = e.value) == null || $.classList.remove("Toolbar--invisible");
    const m = g(_), { width: x, rightPosition: y } = f(), B = q.timeline({
      onComplete() {
        a.value = !1;
      }
    });
    i.value ? B.to(n.value, {
      x: x + G.toolbarOffset,
      duration: m * 0.4,
      ease: G.easeIn
    }).to([e.value, n.value], {
      x: (O) => O === 0 ? -G.toolbarOffset : 0,
      duration: m * 0.6,
      ease: G.easeOut
    }) : (q.set(e.value, {
      y: 0,
      opacity: 1,
      x: y + G.toolbarOffset
    }), B.to([e.value, n.value], {
      x: (O) => O === 0 ? -G.toolbarOffset : 0,
      duration: m,
      ease: G.easeIn
    }));
  }, v = (_ = !1) => {
    const m = g(_), { width: x, rightPosition: y } = f(), B = q.timeline({
      onComplete() {
        a.value = !1;
      }
    });
    i.value ? B.to([n.value, e.value], {
      x: ($) => $ === 0 ? x + G.toolbarOffset : x,
      duration: m * 0.6,
      ease: G.easeIn
    }).to(n.value, {
      x: y,
      duration: m * 0.4,
      ease: G.easeOut
    }) : B.to([n.value, e.value], {
      x: ($) => $ === 0 ? y + G.toolbarOffset : y,
      duration: m,
      ease: G.easeIn,
      onComplete: () => {
        q.set(e.value, {
          y: d()
        });
      }
    });
  }, F = (_ = !1) => {
    const m = g(_);
    q.timeline({
      onComplete() {
        a.value = !1;
      }
    }).to(e.value, {
      bottom: -120,
      x: 0,
      duration: m * 0.3,
      ease: G.easeInOut
    }).to(n.value, {
      bottom: 0,
      duration: m * 0.7,
      ease: G.easeOut
    });
  }, P = (_ = !1) => {
    const m = g(_);
    q.timeline({
      onComplete() {
        a.value = !1;
      }
    }).to(n.value, {
      bottom: "-100%",
      duration: m,
      ease: G.easeOut
    }).to(
      e.value,
      {
        bottom: 0,
        duration: m * 0.5,
        ease: G.easeInOut
      },
      "-=50%"
    );
  }, L = (_ = !1) => {
    const m = g(_, 0.8);
    q.to(t.value, {
      opacity: 1,
      pointerEvents: "all",
      duration: m,
      delay: m,
      ease: G.easeOut
    });
  }, M = (_ = !1) => {
    const m = g(_, 0.6);
    q.to(t.value, {
      opacity: 0,
      pointerEvents: "none",
      duration: m,
      ease: G.easeInOut
    });
  }, S = () => {
    n.value && n.value.removeAttribute("style"), e.value && e.value.removeAttribute("style");
  };
  return xe(() => {
    k(!0), Je(() => {
      var _, m, x;
      q.set(l.value, { opacity: "1" }), c() ? i.value ? (_ = e.value) == null || _.classList.remove("Toolbar--invisible") : (m = e.value) == null || m.classList.add("Toolbar--invisible") : (x = e.value) == null || x.classList.remove("Toolbar--invisible");
    });
  }), {
    showSidePanel: C,
    closeSidePanel: k,
    toogleOnlyToolbarInDesktop: h,
    isSidePanelTransitioningToOpen: r,
    clearPropsSPT: S,
    isTransitioning: a
  };
}, cs = /* @__PURE__ */ se({
  __name: "InfoDrawer",
  props: {
    showToolbar: { type: Boolean, default: !1 },
    downloadItems: { default: () => new Array() },
    forceOpenTab: { type: Boolean, default: !1 },
    tabToOpen: {},
    hasOutline: { type: Boolean, default: !0 },
    hasMetrics: { type: Boolean, default: !0 },
    hasShare: { type: Boolean, default: !0 },
    hasFigures: { type: Boolean, default: !1 },
    hasSupplementaryMaterial: { type: Boolean, default: !1 },
    hasCite: { type: Boolean, default: !0 },
    hasDownload: { type: Boolean, default: !0 },
    heading: { default: "h3" }
  },
  emits: ["download", "close-side-panel", "go-to-id", "update:is-open-side-panel"],
  setup(l, { emit: e }) {
    const n = l, t = A("emitter"), o = A("isDesktopApp"), i = A("isResizingBody"), s = w(null), u = w(null), a = w(null), r = w(!1), c = w(null), d = w(null), p = w(!1), f = Wo(
      a,
      s,
      u,
      c,
      d,
      p,
      r
    ), g = w(null), C = w(!1), k = w(!1), h = w(1441), E = w(!1), v = w(() => {
    }), F = w(!1), P = Ct(), L = () => {
      if (E.value)
        return;
      f.closeSidePanel();
      const x = window.location.hash;
      qn(x) && (window.location.hash = ""), r.value = !1, setTimeout(() => {
        g.value = null, e("close-side-panel");
      }, P);
    }, M = w(Ht(n));
    ae("toolbar", s), ae("sidePanel", u), ae("isOpenSidePanel", r), ae("animations", f), ae("activeTab", g), ae("closeSidePanel", L), ae("isClickingOnTab", C), ae("tabs", M), ae("isChangingTab", k), ae("isOpenMoreOptions", F), ae("hasDownload", n.hasDownload), ae("downloadItems", n.downloadItems), ae("heading", n.heading), ae("goToTab", v);
    const S = (x) => {
      e("download", x);
    };
    K(
      () => [
        n.hasSupplementaryMaterial,
        n.hasFigures,
        n.hasCite,
        n.hasOutline,
        n.hasShare,
        n.hasMetrics
      ],
      () => {
        M.value = Ht(n);
      }
    ), K(
      () => n.showToolbar,
      () => {
        p.value = n.showToolbar, r.value || f.toogleOnlyToolbarInDesktop();
      }
    ), K(
      () => n.forceOpenTab,
      () => {
        if (n.tabToOpen) {
          g.value = un(M.value, n.tabToOpen);
          const x = n.showToolbar ? 600 : 0;
          setTimeout(() => {
            v.value();
          }, x);
        }
      }
    ), K(
      () => o.value,
      () => {
        f.closeSidePanel(!0), r.value && f.showSidePanel(!0);
      }
    ), K(
      () => i.value,
      () => {
        h.value = window.innerWidth, f.clearPropsSPT(), r.value ? f.showSidePanel(!0) : f.closeSidePanel(!0);
      }
    ), K(
      () => r.value,
      () => {
        e("update:is-open-side-panel", r.value), t.emit("is-open-side-panel", r.value), r.value && (E.value = !0, setTimeout(() => {
          E.value = !1;
        }, P));
      }
    );
    const _ = (x) => {
      const y = o.value ? 0 : P;
      o.value || L(), setTimeout(() => {
        e("go-to-id", x);
      }, y);
    }, m = () => {
      o.value || L();
    };
    return xe(() => {
      h.value = window.innerWidth, t.on("go-to-id", _), t.on("close-info-drawer", m), p.value = n.showToolbar, f.toogleOnlyToolbarInDesktop();
    }), $n(() => {
      t.off("go-to-id", _), t.off("close-info-drawer", m);
    }), (x, y) => (I(), D("div", {
      ref_key: "infoDrawer",
      ref: a,
      class: "InfoDrawer"
    }, [
      b("button", {
        ref_key: "overlay",
        ref: c,
        "aria-label": "Close panel",
        class: "InfoDrawer__overlay",
        onClick: L
      }, null, 512),
      W(Mo, { onDownload: S }),
      W(No, null, An({ _: 2 }, [
        ye(M.value, (B) => ({
          name: B.targetId,
          fn: re(() => [
            on(x.$slots, B.targetId, {
              key: B.targetId
            })
          ])
        }))
      ]), 1024),
      b("div", {
        ref_key: "middleStateEl",
        ref: d,
        class: "InfoDrawer__refMiddle"
      }, null, 512)
    ], 512));
  }
});
export {
  oi as P,
  os as _,
  Xt as a,
  ss as b,
  $i as c,
  as as d,
  ls as e,
  rs as f,
  eo as g,
  us as h,
  cs as i,
  Tn as j,
  Gn as m
};
